import Vue from 'vue';
import Vuex from 'vuex';
//import {router} from "../main.js"
import { evtBus  } from '@/main';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { nodes   } from '@/globals/nodes';
import profiler from '@/globals/Profiler';
import { reportUtils } from '@/features/report/lib/reportUtils';
import { anotacaoUtils } from '@/features/anotacoes/lib/AnotacaoUtils';
import { toothUtils } from '@/features/tooth/lib/toothUtils';

import { apps    } from '@/assets/initFiles/apps';

import Victor from 'victor';

import _ from 'lodash';
//import axios from 'axios';

import { undoRedoHistory } from '@/globals/undoRedo';

import { ReportNode, LabelAnnotation, LabelAnnotationLocation } from '@/features/report/models';

Vue.use(Vuex);

// =========================================================================================

const undoRedoPlugin = (store) => {
    undoRedoHistory.store = store;

    // is called AFTER every mutation
    store.subscribe((mutation, state) => {
        var addState,
            payload = mutation.payload || {};

            // addState on moveEnd
            addState = ( (mutation.type == 'MUT_movUpdate') &&
                         ('active' in payload             ) && 
                         (!payload.active                 ) );

        if ('addUndoState' in payload) {
            addState = addState || payload.addUndoState;
        }

        if (addState) {
//            console.log(mutation.type);
            undoRedoHistory.addState(_.cloneDeep(state));
        }
    });
};

// =========================================================================================

const reactivityTracerPlugin = (store) => {
    const mountedComponents = new Set();
    const updateTimes = new Map();
    const computedTracker = new Map();
    const componentTypes = new Set();

    Vue.mixin({
        beforeCreate() {
            const componentName = this.$options.name || 'anonymous';
            componentTypes.add(componentName);
            
            const computed = this.$options.computed;
            if (computed) {
                Object.keys(computed).forEach(key => {
                    const original = computed[key];
                    const wrapped = function() {
                        const computedKey = `${componentName}.${key}`;
                        
                        if (!computedTracker.has(computedKey)) {
                            computedTracker.set(computedKey, 0);
                        }
                        computedTracker.set(computedKey, computedTracker.get(computedKey) + 1);
                        
                        return typeof original === 'function' 
                            ? original.call(this)
                            : original.get.call(this);
                    }
                    
                    if (typeof original === 'function') {
                        computed[key] = wrapped;
                    } else {
                        computed[key] = {
                            get: wrapped,
                            set: original.set
                        }
                    }
                });            
            }
        }
    });

    store.subscribe((mutation, state) => {
        if (mutation.type === 'MUT_runtimeUpdate_mov' && mutation.payload.mousePos) {
            console.group(`Mutation: ${mutation.type}`);
            
            // Don't clear computedTracker here anymore
            updateTimes.clear();

            const componentCounts = new Map();
            mountedComponents.forEach(vm => {
                const name = vm.$options.name || 'anonymous';
                if (!componentCounts.has(name)) {
                    componentCounts.set(name, 0);
                }
                componentCounts.set(name, componentCounts.get(name) + 1);
            });

            // Wait two ticks to ensure all computed properties have been evaluated
            Vue.nextTick(() => {
                Vue.nextTick(() => {
                    console.log('Component Types and Instances:');
                    componentCounts.forEach((count, name) => {
                        console.log(`${name}: ${count} instances`);
                    });

                    console.log('\nComputed Properties Re-evaluated (per component type):');
                    Array.from(componentTypes).forEach(componentName => {
                        const hasComputedProps = Array.from(computedTracker.keys()).some(key => 
                            key.startsWith(componentName)
                        );
                        
                        if (hasComputedProps) {
                            console.log(`\n${componentName}:`);
                            computedTracker.forEach((count, key) => {
                                if (key.startsWith(componentName)) {
                                    console.log(`  ${key.split('.')[1]}: ${count} times`);
                                }
                            });
                        }
                    });
                    
                    // Only clear after logging
                    computedTracker.clear();
                    console.groupEnd();
                });
            });
        }
    });
};

const storeTracerPlugin = (store) => {
    // store.subscribe((mutation, state) => {
    //   console.log(`Mutation: ${mutation.type}`, mutation.payload);
    // });
  
    // store.subscribeAction((action, state) => {
    //   console.log(`Action: ${action.type}`, action.payload);
    // });
  };


// =========================================================================================

const allTools = {};


// =========================================================================================

// --- Getter profiling wrapper ---
function wrapGettersForProfiling(getters) {
    if (!getters) throw new Error('wrapGettersForProfiling: getters is undefined or null');
    const wrapped = {};
    Object.entries(getters).forEach(([key, fn]) => {
        if (typeof fn === 'function') {
            wrapped[key] = function(...args) {
                if (typeof profiler.logEvent === 'function') profiler.logEvent('getter', key);
                // console.log('getter.applied', key);
                return fn.apply(this, args);
            };
        } else {
            wrapped[key] = fn;
        }
    });
    return wrapped;
}


const rawGetters = {
    GET_activeJob: state => {
        return state.job;
    },

    GET_jobTools: state => { 
        return state.job.tools;
    },

    GET_jobMetrics: state => {
        return state.job.metrics;
    },

    GET_jobInfoType: state => {
        return state.job.info?.type || gConsts.job.info.type.NEW;
    },

    // -----------------------------------------------------------------

    GET_activeLabelTools: state => {
        return state.job.tools.filter(tool => (
            tool.label.id == state.runtime.active.label
        ));
    },

    // -----------------------------------------------------------------

    GET_activeLabelAndLocationTools: state => { 
        var nodes = state.setup.proj.nodes,
            job   = state.job;

        return job.tools.filter(tool => (                
                ( (tool.label.id == state.runtime.active.label                                   ) ||
                (nodes.get(tool.label.layer).layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION) )
        ));
    },

    // -----------------------------------------------------------------
    
    GET_activeLayerTools: state => { 
        return state.job.tools.filter(tool => (tool.label.layer == state.runtime.active.layer));
    },

    // -----------------------------------------------------------------

    GET_activeLayerAndLocationTools: state => { 
        var nodes = state.setup.proj.nodes,
            job   = state.job;

        return job.tools.filter(tool => (
                ( (tool.label.layer == state.runtime.active.layer                                   ) ||
                (nodes.get(tool.label.layer).layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION) )
        ));
    },

    // -----------------------------------------------------------------

    GET_locationTools: state => { 
        var nodes = state.setup.proj.nodes,
            job   = state.job;

        return job.tools.filter(tool => (nodes.get(tool.label.layer).layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION));
    },

    GET_regioesAnatomicasTools: (state, getters) => { 
        return getters.GET_locationTools.filter(tool => (tool.label.layer == gConsts.layer.locations.ANAT_REGIONS));
    },

    // -----------------------------------------------------------------

    GET_teethLETools: state => { 
        return state.job.tools.filter(tool => (
            (tool.label.layer == gConsts.layer.locations.TEETH_LE) && 
            (tool.attrib.type  == gConsts.tool.attrib.types.RETA  ) // pode ter outras marcacoes alem do longoEixo (como supranumerarios)
        ));
    },

    // -----------------------------------------------------------------

    GET_teethLETools_sorted: (state, getters) => {
        return getters.GET_teethLETools.sort((a, b) => a.label.text.localeCompare(b.label.text));
    },

    // -----------------------------------------------------------------

    GET_teethSegTools: state => { 
        return state.job.tools.filter(tool => (tool.label.layer == gConsts.layer.locations.TEETH_SEG));
    },

    // -----------------------------------------------------------------
    
    GET_teethSegTools_sorted: (state, getters) => {
        return getters.GET_teethSegTools.sort((a, b) => a.label.text.localeCompare(b.label.text));
    },

    // -----------------------------------------------------------------

    GET_denteTools: (state, getters) => { 
        return getters.GET_teethSegTools;
    },

    // -----------------------------------------------------------------

    GET_activeDenteTools: (state, getters) => { 
        return getters.GET_denteTools.filter(dente => (dente.label.id == state.runtime.active.dente));
    },

    GET_toothRegionRect: (state, getters) => {
        if (getters.GET_jobMetrics.teeth.meanWidth == 0 || getters.GET_jobMetrics.teeth.meanHeight == 0) {
            return {
                width: 50,
                height: 50,
            }
        }
        const rect = {
            width: getters.GET_jobMetrics.teeth.meanWidth * 0.7,
            height: getters.GET_jobMetrics.teeth.meanWidth * 0.7,
        }

        return rect;
    },

    // -----------------------------------------------------------------

    GET_doubtTools: state => { 
        return state.job.tools.filter(tool => (
            tool.state.confidence == gConsts.tool.state.confidence.DOUBT
        ));
    },

    // -----------------------------------------------------------------

    GET_jobs: state => { 
        var jobs = state.setup.instance.jobs;
        return (jobs 
            ? jobs 
            : (state.runtime.events.jobLoaded 
                ? [state.job]
                : []));
    },

    // -----------------------------------------------------------------
    
    GET_emptyJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.EMPTY));
    },

    // -----------------------------------------------------------------

    GET_partialJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.PARTIAL));
    },

    // -----------------------------------------------------------------

    GET_doubtJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.DOUBT));
    },

    // -----------------------------------------------------------------

    GET_divergentJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.DIVERGENT));
    },

    // -----------------------------------------------------------------

    GET_discardedJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.DISCARDED));
    },

    // -----------------------------------------------------------------

    GET_completedJobs: (state, getters) => { 
        return getters.GET_jobs.filter(job => (job.state == gConsts.job.states.CONFIRMED));
    },

    // -----------------------------------------------------------------

    GET_dentesPresentes(state, getters) {
        return getters.GET_teethSegTools_sorted.map((dente) => dente.label.id);
    },

    GET_dentesPresentesText(state, getters) {
        var dentes;

        var currentDenticao = getters.GET_selectedDenticaoReportNode?.id;

        switch (currentDenticao) {
            case gConsts.denticao.types.DECIDUA : dentes = gConsts.denticao.dentes.DECIDUA; break;
            case gConsts.denticao.types.MISTA   : dentes = gConsts.denticao.dentes.MISTA  ; break;
            default: dentes = gConsts.denticao.dentes.PERMANENTE;
        }

        return getters.GET_teethSegTools_sorted
            .filter(dente => dentes.includes(dente.label.text))
            .map(dente => dente.label.text);
    },

    // -----------------------------------------------------------------

    GET_dentesNodes(state, getters) {
        var dentes,
            denteNodes = [],
            nodesArray = state.setup.proj.nodesArray,
            denticao = state.job.elems[state.runtime.active.elemIdx].labels[gConsts.denticao.LAYER];

        switch (denticao) {
            case gConsts.denticao.types.DECIDUA : 
            case gConsts.denticao.types.MISTA   : dentes = gConsts.denticao.dentes.MISTA  ; break;
            default: dentes = gConsts.denticao.dentes.PERMANENTE;
        }

        dentes.forEach(denteStr => {
            const denteNode = nodesArray.find(node => node.layout.caption == denteStr);
            if (denteNode) {
                denteNodes.push(denteNode);
            }
        });            

        return denteNodes;
    },

    GET_dentesAusentesNodes(state, getters) {
        var dentes,
            ausentes = [],
            nodesArray = state.setup.proj.nodesArray,
            denticao = state.job.elems[state.runtime.active.elemIdx].labels[gConsts.denticao.LAYER];

        // console.log('--------------------------------------------');
        // console.log(denticao);
        // console.log(gConsts.denticao.types.PERMANENTE);
        // console.log(gConsts.denticao.dentes.PERMANENTE);

        switch (denticao) {
            case gConsts.denticao.types.DECIDUA : 
            case gConsts.denticao.types.MISTA   : dentes = gConsts.denticao.dentes.MISTA  ; break;
            default: dentes = gConsts.denticao.dentes.PERMANENTE;
        }

        dentes.forEach(denteStr => {
            if (!getters.GET_teethSegTools_sorted.find(denteTool => denteTool.label.text == denteStr)) {
                const denteNode = nodesArray.find(node => node.layout.caption == denteStr);
                if (denteNode) {
                    ausentes.push(denteNode);
                }
            }
        });            

        return ausentes;
    },

    GET_dentesAusentesText(state, getters) {
        var dentes,
            ausentes = [];

        var currentDenticao = getters.GET_selectedDenticaoReportNode?.id;

        switch (currentDenticao) {
            case gConsts.denticao.types.DECIDUA : dentes = gConsts.denticao.dentes.DECIDUA; break;
            case gConsts.denticao.types.MISTA   : dentes = gConsts.denticao.dentes.MISTA  ; break;
            default: dentes = gConsts.denticao.dentes.PERMANENTE;
        }

        dentes.forEach(denteStr => {
            if (!getters.GET_teethSegTools_sorted.find(denteTool => denteTool.label.text == denteStr)) {
                ausentes.push(denteStr);
            }
        });            

        return ausentes;
    },

    // -----------------------------------------------------------------

    GET_usedLabels: (state, getters) => { 
        var activeLayer, 
            toolsToConsider = [],
            usedLabels = [],
            rt    = state.runtime,
            nodes = state.setup.proj.nodes;

        if (nodes) {
            activeLayer = nodes.get(rt.active.layer);
            if (rt.active.dente != null) {
                toolsToConsider = getters.GET_activeDenteTools;
            } else {
                if (activeLayer.tools.visibility.includes(gConsts.node.tools.visibility.LAYER)) {
                    toolsToConsider = getters.GET_activeLayerTools;
                }
            }

            toolsToConsider.forEach(tool => usedLabels.push(tool.label.id));
        }

        return usedLabels;
    },

    // -----------------------------------------------------------------

    GET_unusedLabels: (state, getters) => { 
        var labels = getters.GET_labels,
            usedLabels = getters.GET_usedLabels;
        
        return labels.filter(label => !usedLabels.includes(label.id));
    },

    GET_activeDente : (state, getters) => {
        if (!state.runtime.active.dente)
            return null;
        return getters.GET_denteTools.find(dente => (dente.label.id == state.runtime.active.dente));
    },

    // -----------------------------------------------------------------

    // Computed values shared by all components
    GET_projNodes         : state => state.setup.proj.nodes,
    GET_appSidePanels     : state => state.setup.app.sidePanels, 
    GET_appToolbars       : state => state.setup.app.toolbars, 
    GET_activeToolbarButton : state => state.ui.toolbar.button,
    GET_initParamsToken   : state => state.setup.initParams.token,
    GET_jobState          : state => state.job.state, 
    GET_activeTool        : state => state.runtime.active.tool,
    GET_activeDenteLabelId: state => state.runtime.active.dente,
    GET_activeNodes       : state => state.runtime.active.nodes,
    GET_activeLabel       : state => state.runtime.active.label,
    GET_activeLayer       : state => state.runtime.active.layer,
    GET_movType           : state => state.runtime.mov.type,
    // GET_movMousePos       : state => state.runtime.mov.mousePos,
    GET_movTool           : state => state.runtime.mov.tool,
    GET_movToolPt         : state => state.runtime.mov.toolPt,
    GET_movToolOffset     : state => state.runtime.mov.toolOffset,
    GET_jobLoaded         : state => state.runtime.events.jobLoaded,
    GET_elemsLoaded       : state => state.runtime.events.elemsLoaded,
    GET_waImgBC           : state => state.ui.workArea.imgBC,
    GET_waZoomScale       : state => state.ui.workArea.zoom.scale,
    GET_waZoomOffset      : state => state.ui.workArea.zoom.offset,
    GET_nodeSearchStr     : state => state.ui.sidePanels.nodeSearchStr,
    GET_activeSp          : state => state.ui.sidePanels.activeSp,
    GET_togglesNodeSearch : state => state.ui.toggles.nodeSearch,
    GET_togglesCrossHair  : state => state.ui.toggles.crossHair,
    GET_togglesImgOrigin  : state => state.ui.toggles.imgOrigin,

    // -----------------------------------------------------------------

    GET_reportNodes(state, getters) {
        return state.job.report.nodes;
    },

    GET_reportNodes_validated(state, getters) {
        let reportNodes = getters.GET_reportNodes.filter(reportNode => reportNode.info.validated);
        reportNodes = reportNodes.filter(reportNode => {
            if (reportNode.layout.type == gConsts.node.layout.types.LAYER) {
                return reportNodes.some(child => child.layout.parent == reportNode.id && child.info.validated);
            }
            return true;
        });

        reportNodes = reportNodes.filter(reportNode => {
            if (reportNode.layout.type == gConsts.node.layout.types.STEP) {
                return reportNodes.some(child => child.layout.parent == reportNode.id && child.info.validated);
            }
            return true;
        });
        
        return reportNodes
    },

    GET_lastAddedCustomLineId(state, getters) {
        return state.runtime.report.state.lastAddedCustomLineId;
    },

    GET_selectedDenticaoReportNode(state, getters) {
        return getters.GET_reportNodes.find(reportNode => reportNode.layout.parent == 'layer_tipoDenticao');
    },

    GET_nodesArray(state, getters) {
        if (getters.GET_jobLoaded && (!state.setup.proj.nodesArray))  {
            state.setup.proj.nodesArray = Array.from(state.setup.proj.nodes?.values() || []);
        }
        return state.setup.proj.nodesArray; 
    },  

    GET_filteredNodes(state, getters) {
        var filteredLabels, filteredAncestors;

        if ( (getters.GET_nodeSearchStr == '') && 
                (getters.GET_execModeWORK       ) ) {
            return getters.GET_nodesArray || [];
        }

        // return getters.GET_nodesArray.filter(node => getters.GET_reportNodes.find(reportNode => reportNode.id == node.id));
        return getters.GET_nodesArray || [];
    },

    // GET_filteredNodes(state, getters) {
    //     var filteredLabels, filteredAncestors;

    //     if ( (getters.GET_nodeSearchStr == '') && 
    //             (getters.GET_execModeWORK       ) ) {
    //         return getters.GET_nodesArray;
    //     }

    //     filteredLabels    = nodes.getFilteredLabels();            
    //     filteredAncestors = nodes.getNodesAncestors(filteredLabels);  // Gets all ancestor nodes of the filteredLabels
        
    //     return [...filteredLabels, ...filteredAncestors];
    // },

    GET_labelLocations(state, getters) {
        var dente,
            lbLocations = new Map();

        if (getters.GET_jobLoaded) {
            // Loop through the tool list and check for matching nodes
            getters.GET_jobTools.forEach(tool => {
                if (getters.GET_projNodes.has(tool.label.id)) {
                    // Perform action if there's a match
                    dente = nodes.getNode(tool.dente)?.layout?.label;
                    if (dente) {
                        if (!lbLocations.has(tool.label.id)) {
                            lbLocations.set(tool.label.id, []);
                        }
                        
                        if (!lbLocations.get(tool.label.id).includes(dente)) {
                            lbLocations.get(tool.label.id).push(dente);
                        }
                    }
                }
            });
        }

        return lbLocations;
    },

    // -----------------------------------------------------------------

    GET_locationLabels(state, getters) {
        var lbNode, lbLayerNode,
            locLabels = new Map();
        
        if (getters.GET_jobLoaded) {
            // Loop through the tool list and check for matching nodes
            getters.GET_jobTools.forEach(tool => {
                if (tool.dente) {
                    lbNode = getters.GET_projNodes.get(tool.label.id);
                    if (lbNode) {                            
                        if (lbNode.layout.type == gConsts.node.layout.types.LABEL) {
                            lbLayerNode = getters.GET_projNodes.get(lbNode.layout.parent);

                            if (lbLayerNode.layerTools.pFunction != gConsts.node.layerTools.pFunctions.LOCATION) {
                                if (!locLabels.has(tool.dente)) {
                                    locLabels.set(tool.dente, []);
                                }
                                
                                if (!locLabels.get(tool.dente).includes(tool.label.id)) {
                                    locLabels.get(tool.dente).push(tool.label.id);
                                }
                            }
                        }
                    }
                }
            });

            // locLabels.forEach((labels, location) => {
            //     console.log(`${location}: ${labels}`);
            // })
        }

        return locLabels;
    },
    
    // -----------------------------------------------------------------

    GET_activeLayerNode(state, getters) { 
        return nodes.getNode(getters.GET_activeLayer);
    },

    GET_activeLabelNode(state, getters) { 
        return nodes.getNode(getters.GET_activeLabel);
    },

    GET_activeLabelReportNode(state, getters) { 
        return getters.GET_reportNodes.find(reportNode => reportNode.id == getters.GET_activeLabel);
    },
    
    GET_activeLabelLabel(state, getters) { 
        return nodes.getNode(getters.GET_activeLabel)?.layout.label ?? '';
    },
    GET_activeLabelCaption(state, getters) { 
        return nodes.getNode(getters.GET_activeLabel)?.layout.caption ?? '';
    },
    GET_activeLabelColor(state, getters) { 
        return nodes.getNode(getters.GET_activeLabel)?.layout.color ?? '';
    },
    GET_activeStepCaption(state, getters) { 
        return nodes.getNode(state.runtime.active.step)?.layout.caption ?? '';
    },
    GET_rootNodes : (state, getters) => {
        return getters.GET_filteredNodes.filter(
            node => (node.layout.parent === gConsts.node.layout.parents.ROOT)
        );
    },
    GET_hasLocationLayer_teethLE(state) {
        let layer = state.setup.proj.nodes.get(gConsts.layer.locations.TEETH_LE);
        return (layer?.layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION);
    },
    GET_hasLocationLayer_teethSeg(state) {
        let layer = state.setup.proj.nodes.get(gConsts.layer.locations.TEETH_SEG);
        return (layer?.layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION);
    },
    GET_tipoDenticao(state) {
        return this.GET_activeElem?.labels?.[gConsts.denticao.LAYER] || 'Indefinido';  // UEI!! - não vai funcionar pq não vai escolher nenhuma opção no selectLayer ... tvz tenha que colocar uma 4a opção, indefinido.
    },
    GET_job(state) {
        return state.runtime.events.jobLoaded ? state.job : null; 
    },
    GET_execMode(state) {
        return state.runtime.execMode;
    },
    GET_execModeWORK(state) { 
        return (state.runtime.execMode == gConsts.rt.execModes.WORK); 
    },
    GET_execModeVIEW(state) { 
        return (state.runtime.execMode == gConsts.rt.execModes.VIEW); 
    },
    GET_activeElem : (state, getters) => {
        return getters.GET_job?.elems[state.runtime.active.elemIdx];
    },
    GET_activeImg : (state, getters) => {
        return getters.GET_activeElem?.img
    },
    GET_colorTheme(state) { 
        return gConsts.ui.colorTheme.data[state.ui.colorTheme] 
    },

    /* Getters de configuracao do report */
    GET_report_configVisualizacao(state) {
        return state.runtime.report.config.visualizacao;
    },
    GET_report_configVisualizacao_showLabelColorSquare(state) {
        return state.runtime.report.config.visualizacao.showLabelColorSquare;
    },
    GET_report_configVisualizacao_hideLayerTitle(state) {
        return state.runtime.report.config.visualizacao.hideLayerTitle;
    },
    GET_report_configVisualizacao_hideSectionTitle(state) {
        return state.runtime.report.config.visualizacao.hideSectionTitle;
    },
    GET_report_configVisualizacao_removeLabelAnnotationStyle(state) {
        return state.runtime.report.config.visualizacao.removeLabelAnnotationStyle;
    },

};

// =========================================================================================

export default new Vuex.Store({
    strict: true,

//    plugins: [undoRedoPlugin, reactivityTracerPlugin],
    plugins: [undoRedoPlugin, storeTracerPlugin],

//    plugins: [undoRedoPlugin],

    /* 
        A estrutura [state] refletem o fluxo de execução do RMInteract.
        * Fases do ciclo de execução do sistema.
            - Setup inicial
                + Carregamento dos dados de [setup] obtidos do servidor a partir da 
                    [url/token] passados como parâmetros na tag HTML do RMInteract).
                + [main], [io], [app], [proj], [config] e [instance].
            
            - Load do [job].
                + [job] : dados do exame corrente.
                    . Logo após o setup inicial (recebido na 1a chamada ao servidor).
                    . Ou quando escolhemos outro [job] da [instancia], quando for o 
                        [RMAnnotations] (usando a chamada getJob). 
            
            - Execução do sistema.
                + [runtime] : gerenciamento do estado interno de execução do sistema.
                + [ui]      : gerenciamento da interação com o usuário (WorkArea, toolbar, 
                                sidePanels e toggles de funcoes)

            - Salvar o [job].
                + [job] : salvamos os dados do exame corrente, quando no save manual,
                            salva, quando mudamos de [job] da [instancia] (RMAnnotations)
                            ou quando finalizamos a execução do app.
            
            - Finalização da execução
                + Salvamos o [job], [setup.proj.custom] e o [setup.config] caso tenham 
                    sido alterados. 
        
        * State object
        State {
            // Dados de inicialização do sistema.
            setup : {
                initParams  // Dados de inicialização recebidos da tag HTML do componente (initParams).                
                app         // Dados de configuração do app (especificado no job) / [init.JSON] e [projects.js].                
                proj        // Dados iniciais de projeto (especificado no job) / [init.JSON] e [projects.js].                
                config      // Dados config. do sistema / [init.JSON] e [projects.js].                
                instance    // Lista de jobs a serem trabalhados (para app = Annotations) / [init.JSON].
            }    

            // Dados do job corrente (carregados no setup inicial e atualizados durante toda 
            // a execução do sistema / [init.JSON] ou [getJob] (app = Annotation)
            job : {
                info     // dados do job (obs etc.)
                patient  // dados cadastrais do patient ( name, sex, birthday, dentist, obs )
                state    // estado do job state (gConsts.job.states = EMPTY, PARTIAL, CONFIRMED, etc.)
                elems    // imagens do exame
                tools    // annotações do exame
                report   // relatório do exame
                reportNodes // nodes do relatório do exame
                metrics  // levantamento dos tamanhos de algumas estruturas dentárias do paciente
            }

            // Controla/gerencia os dados/estado de execução do sistema.
            runtime : {
                execMode        // modo de execução corrente do sistema.
                active          // pointers/referências ou indices das entidades ativas.                 
                mov             // controla a interação da imagem e tools no WorkArea
                events          // gerencia eventos importantes do fluxo de execução do sistema.
                serialCounters  // contador de inserção de tools
            }

            // Gerencia a interação do usuário com a UI.
            ui : {
                workArea    // visual da imagem (zoom e BC)
                toolbar     // ações/estados ligados à toolbar
                sidePanels  // ações/estados ligados aos sidePanels
                toggles     // gerencia estados de ativação de alguns recursos da UI.
            }
        }
    */
    state: {
        setup : {
            pxPerMm : -1,

            // Dados de inicialização recebidos da tag HTML do componente (initParams).
            initParams : {
                url      : '',                         // url do backend
                token    : '',                         // token de autenticação para comunicação com o backend
                execMode : gConsts.rt.execModes.WORK,  // modo de execução inicial (default)
                compId   : ''                          // usado para não dar colisão de DOM elems IDs ...
            },

            // Dados de configuração do app (especificado no job) / [init.JSON] e [projects.js].
            app : {
                info       : null,  // { name, description }
                id         : '', 
                toolbars   : [],    
                sidePanels : []      
            },

            // Dados iniciais de projeto (especificado no job) / [init.JSON] e [projects.js].
            proj : {
                info   : null,  // { name, description }
                id     : '',
                nodes  : null,  // [map] de nodos do projeto do job (original com as customizações do usuario aplicadas)
                custom : null,  // { clinic, user } / personalizações do usuário aplicadas aos nodes
                locationLayers : {
                    teethSeg    : false,
                    teethLE     : false,
                    antContours : false,
                    anatRegions : false,
                    anatPts     : false,        
                }
            },

            // Dados config. do sistema / [init.JSON] e [projects.js].
            config : {
                labelPos        : gConsts.tool.labelPos.END, 
                closedPaths     : false,
                labelJump       : false,
                toothNav        : gConsts.dente.navTypes.DYNAMIC,
                centerTooth     : false,
                labelOpac       : 1,
                toolOpac        : 1,
                anomHeatMapOpac : 0,
                dentesROIFactor : 10,
            },

            // Lista de jobs a serem trabalhados (para app = Annotations) / [init.JSON]
            instance : {
                info : null,  // { name, description }
                name : '',    // Nome do projeto de annotação (antigo "folder").
                jobs : [],  // []
            },
        },    

        /* Dados do job corrente (carregados no setup inicial e atualizados durante toda 
           a execução do sistema / [init.JSON] ou [getJob] (app = Annotation) */
        job : {
            info    : { obs : '' },
            patient : null,  // { name, sex, birthday, dentist }
            state   : gConsts.job.states.EMPTY,
            elems   : null,  
            tools   : [],  
            // report  : '',
            report: {
                /** @type {ReportNode[]} */
                nodes: [], 
            },
            metrics : {
                teeth : {
                    meanWidth  : 0,
                    meanHeight : 0,
                    meanLE     : 0  // antigo cInfo.leMean
                },
                arch : {
                    width  : 0,
                    height : 0
                }
            },
        },

        // Controla/gerencia os dados/estado interno de execução do sistema.
        runtime : {            
            execMode : gConsts.rt.execModes.WORK,  // modo de execução ativo do sistema.

            // Pointers/referências ou indices das entidades ativas.
            active : {       
                jobIdx   : -1,  // usado quando tem uma instancia carregada                
                elemIdx  :  0,  // por eqto só tenho uma imagem
                sliceIdx : -1,  // por eqto não tem multi-slice

                tool  : null,
                dente : null,
                locations  : null,
                qualifiers : null,

                nodes : null,
                step  : '',
                layer : '',
                label : '',
            },

            // controla a interação da imagem e tools no WorkArea
            mov  : {
                active        : false,
                type          : -1,
                moved         : false,
                dragging      : false,
                target        : '',
                mousePos      : {x : 0, y : 0 },
                // mouseLocation : '',

                tool          : null, 
                toolPt        : -1,
                toolOffset    : {x : 0, y : 0 },        
            },

            // gerencia eventos importantes do fluxo de execução do sistema.
            events : {
                jobLoaded   : false,
                savePending : false,
                elemsLoaded : false,  // old [imgLoaded]
            },

            report: {
                config: {
                    visualizacao: {
                        showLabelColorSquare: false,
                        hideLayerTitle: false,
                        hideSectionTitle: false,
                        removeLabelAnnotationStyle: false,
                    }
                },
                state: {
                    /** @type {string | null} */
                    lastAddedCustomLineId: null,
                }
            },

            serialCounters : { tool : -1 },
        },

        ui : {               
            workArea : {
                imgBC : { brightness : 100, contrast : 100 },

                zoom  : { 
                    scale  : 1,
                    offset : { x : 0, y : 0 },
                }, 
            },

            toolbar : {    
                toolType : gConsts.tool.attrib.types.NO_TOOL,
                button   : gConsts.ui.toolbar.buttons.WA_PAN,        
            },

            sidePanels : {                 
                activeSp      : '',
                nodeSearchStr : '',
                spAnnotSide   : '',
            },

            // gerencia estados de ativação de alguns recursos do sistema.
            toggles : {
                crossHair       : false,
                imgOrigin       : false,     
                clearImgView    : false,                        
                showToolHandles : false,
                nodeSearch      : false,
            },        

            colorTheme : gConsts.ui.colorTheme.themes.LIGHT
        }
    },

    // =========================================================================================

    getters: wrapGettersForProfiling(rawGetters),
    // getters: rawGetters,

    // =========================================================================================

    mutations: {
        MUT_setup: (state, payload) => {
            var setup = state.setup;

            help.updateObj(setup, payload, ['pxPerMm']);

            help.updateObj(setup.initParams, payload.initParams, 
                ['url', 'token', 'execMode', 'compId']);
            if ('execMode' in payload.initParams) {
                state.runtime.execMode = payload.initParams.execMode;
            }

            help.updateObj(setup.app, payload.app, 
                ['info', 'id', 'toolbars', 'sidePanels']);

            help.updateObj(setup.proj, payload.proj, 
                ['info', 'id', 'nodes', 'custom']);            

            help.updateObj(setup.config, payload.config,
                ['labelPos', 'closedPaths', 'labelJump', 'toothNav', 
                 'centerTooth', 'labelOpac', 'toolOpac', 'anomHeatMapOpac', 
                 'dentesROIFactor']);

            if ('instance' in payload) {
                help.updateObj(setup.instance, payload.instance, 
                    ['info', 'name', 'jobs']);
            }
        },

        // -----------------------------------------------------------------

        MUT_setupUpdate_config: (state, payload) => {
            var config = state.setup.config;

            help.updateObj(config, payload, 
                ['labelPos', 'closedPaths', 'labelJump', 'toothNav', 
                 'centerTooth', 'labelOpac', 'toolOpac', 'anomHeatMapOpac', 
                 'dentesROIFactor']);
   
            // Itera todas as configurações presentes no payload e salva elas no locaStorage.
            Object.entries(payload).forEach(([key, value]) => {
                utils.localStorage_setItem('setup.config.' + key, value);
            });
        },

        // -----------------------------------------------------------------

        MUT_loadJob: (state, payload) => {
            var serial,
                nodes  = state.setup.proj.nodes,
                job    = state.job,
                rt     = state.runtime;
    
            rt.events.jobLoaded = false;
            // TODO: Verificar se precisar mapear o formato que vem do job para o novo relatorio. Provavelmente vai ser o mesmo salvo com novo.
            help.updateObj(job, payload, 
                ['info', 'patient', 'state', 'elems']);

            // No loadJob o estado do job eh resetado (caso houvesse outro carregado anteriormente)
            serial = 0;  
            job.tools = [];
            payload.tools.forEach(tool => {
                if (!tool.id)
                    tool['id'] = 'tool' + '_' + tool.attrib.type + '[' + (serial++) + ']' + '[' + tool.label.id + ']';
                else
                    serial++;
                if (!tool.label.text)
                    tool.label.text = nodes.get(tool.label.id).layout.label;
                if (!tool.dente)
                    tool.dente = (tool.locations.external.list.length > 0) ? tool.locations.external.list[0] : '';
                if (!tool.locations.regions)
                    tool.locations.regions = {
                        list : [],
                        custom : ''
                    }
                job.tools.push(tool);
            });

            // console.log('job.tools: ' + JSON.stringify(job.tools.filter(tool => tool.id.includes('lb_dente')).map(tool => tool.id)));
            rt.serialCounters.tool = serial;
            rt.events.jobLoaded = true;

            if (payload.report?.nodes?.length > 0) {
                job.info.type = gConsts.job.info.type.EDIT;
                payload.report.nodes.forEach(reportNodeObject => {
                    const reportNode = ReportNode.fromObject(reportNodeObject);
                    if (reportNode) {
                        job.report.nodes.push(reportNode);
                    }
                });
            } else {
                job.info.type = gConsts.job.info.type.NEW;
                console.time('MUT_loadJob: Adicionando anotacoes dos labels ao report');
                job.tools.forEach(tool => {
                    if (nodes.has(tool.label.id)) {
                        var labelReportNode = job.report.nodes.find(reportNode => reportNode.id == tool.label.id);
                        if (!labelReportNode) {
                           labelReportNode = help.addNewReportNode(job.report.nodes, state, tool.label.id, 'auto');
                        }
                        
                        if (labelReportNode) {
                            help.addToolAnnotationForReportLabel(labelReportNode.annotation.list, tool, state);
                        }
                    }
                });
                console.timeEnd('MUT_loadJob: Adicionando anotacoes dos labels ao report');

                if (payload.elems[rt.active.elemIdx]?.labels && 'layer_tipoDenticao' in payload.elems[rt.active.elemIdx].labels) {
                    // var layerTipoDenticaoReportNode = job.report.nodes.find(reportNode => reportNode.id == 'layer_tipoDenticao');
                    // if (!layerTipoDenticaoReportNode) {
                    //     help.addNewReportNode(job.report.nodes, state, 'layer_tipoDenticao');
                    // }
                    // Verifico se o valor vindo esta definido nos nodes corretamente
                    const valorTipoDenticao = payload.elems[rt.active.elemIdx].labels['layer_tipoDenticao'];
                    if (nodes.get(valorTipoDenticao)?.layout?.parent == 'layer_tipoDenticao') {
                        help.addNewReportNode(job.report.nodes, state, valorTipoDenticao);
                    }
                } else {
                    // Se não houver valor definido, adiciono o node layer_tipoDenticao para mostrar o seletor no report inicialmente 
                    help.addNewReportNode(job.report.nodes, state, 'layer_tipoDenticao');
                }

                // console.log('job.report.nodes: ' + JSON.stringify(job.report.nodes));

                console.time('MUT_loadJob: Calculando texto inicial do report');
                job.report.nodes.forEach(reportNode => {
                    if (reportNode.annotation.list?.length > 0) {
                        reportNode.reportText = reportUtils.getInitialReportText(nodes.get(reportNode.id), reportNode.annotation.list);
                    }
                });
                console.timeEnd('MUT_loadJob: Calculando texto inicial do report');

            }

            state.job.metrics = help.setJobMetrics(state);
            console.log('MUT_loadJob: state.job.metrics: ', JSON.stringify(state.job.metrics));
        },

        // -----------------------------------------------------------------

        MUT_jobUpdate: (state, payload) => {
            var inputTools,
                rt = state.runtime,
                nodes = state.setup.proj.nodes,
                job   = state.job,
                elem  = state.job.elems[state.runtime.active.elemIdx],
                tools = state.job.tools;                

            if ('state' in payload) {
                switch (payload.state) {
                    case gConsts.job.states.EMPTY :  
                    case gConsts.job.states.DISCARDED :
                        break;
        
                    case gConsts.job.states.CONFIRMED :
                        inputTools = tools.filter(tool => ( 
                            (tool.label.layer != ''                                                                          ) &&
                            (nodes.get(tool.label.layer).layerTools.pFunction == gConsts.node.layerTools.pFunctions.LOCATION)
                        ));
                        inputTools.forEach(tool => {  // passa todas as inputTools pro state OK
                            tool.state.confidence = gConsts.tool.state.confidence.OK;
                        });
                        break;
                }
                help.updateObj(job, payload, ['state']);
                rt.events.savePending = true;
            }

            if ('labels' in payload) {
                payload.labels.forEach(label => {
                    elem.labels[label.layer] = label.id;    
                })
//                console.log('labels[layer]: ' + elem.labels[payload.label.layer]);
            }
        },

        // -----------------------------------------------------------------

        MUT_runtimeUpdate: (state, payload) => {
            help.updateObj(state.runtime, payload, ['execMode']);
        },

        // -----------------------------------------------------------------

        MUT_runtimeUpdate_active: (state, payload) => {
            var nodes  = state.setup.proj.nodes,
                active = state.runtime.active,
                mov    = state.runtime.mov,
                config = state.setup.config;

            help.updateObj(active, payload, 
                ['jobIdx', 'elemIdx', 'sliceIdx', 
                 'tool', 'dente', 'qualifiers',
                 'nodes', 'step', 'layer', 'label']);

            if ('jobIdx' in payload) {                
                utils.localStorage_setItem('rt.active.jobIdx', active.jobIdx);
                
                active.elemIdx    = 0;
                active.sliceIdx   = -1;
                active.tool       = null;
                active.dente      = null;
                // active.locations  = null;
                // active.qualifiers = null;
            }

            if (('layer' in payload) && payload.layer != null) {
                config.labelJump = (nodes.get(payload.layer).layerTools.jumpOnToolInput);
                active.dente = null;
               
                mov.tool = null;
                mov.type = -1;

                if (!('label' in payload)) { 
                    active.label = '';    
                }
            }
        },

        // -----------------------------------------------------------------

        MUT_runtimeUpdate_mov: (state, payload) => {
            var tool,
                config = state.setup.config,
                rt     = state.runtime,
                mov    = state.runtime.mov;

        //    profiler.profileBlock('Code block', 'Store.MUT_runtimeUpdate_mov', '[tool.coords/tool.dente]', () => {
            // se tinha um [mov.type == TOOL_DRAG] ativo e estah terminando agora
        //     if ( (mov.active                                ) && 
        //             (mov.tool != null                          ) &&  // soh pra garantir 
        //             (mov.type == gConsts.mov.types.TOOL_DRAG   ) &&
        //             (('active' in payload) && (!payload.active)) ) {

        //         // aplica o offset do movimento nas coordenadas reais da tool
        //         tool = mov.tool;
        //         tool.coords.pts.forEach(pt => {
        //             pt.x += mov.toolOffset.x;
        //             pt.y += mov.toolOffset.y;
        //         });
        //         mov.toolOffset = {x: 0, y: 0};

        //         // Se o drag da tool terminou em outro dente, associamos ela a este novo dente
        //         if ((rt.active.dente != null) && (tool.dente != rt.active.dente)) {
        //             tool.dente = rt.active.dente;
        //         }                
        //     }
        //    });

        //    profiler.profileBlock('Code block', 'Store.MUT_runtimeUpdate_mov', '[mousePos]', () => {
        //     if ('mousePos' in payload) {
        //         // Optimize reactivity: update only properties, do not replace the object
        //         mov.mousePos.x = payload.mousePos.x;
        //         mov.mousePos.y = payload.mousePos.y;
        //         // Vue.set(mov, 'mousePos', { x: payload.mousePos.x, y: payload.mousePos.y });
        //     }
        //    });

        //    profiler.profileBlock('Code block', 'Store.MUT_runtimeUpdate_mov', '[updateObj]', () => {
        //     help.updateObj(mov, payload,
        //         ['active', 'type', 'moved', 'dragging', 'target', 'tool', 'toolPt']);
        //    });

        //    profiler.profileBlock('Code block', 'Store.MUT_runtimeUpdate_mov', '[active.tool]', () => {
        //     if ((mov.tool != null) && (mov.tool != rt.active.tool)) {
        //         rt.active.tool = mov.tool;
        //         console.log('Setting rt.active.tool from mov.tool:', mov.tool.id);                
        //     }
        //    });	

        //    profiler.profileBlock('Code block', 'Store.MUT_runtimeUpdate_mov', '[active.dente = null]', () => {
        //     if (mov.mouseLocation != gConsts.mov.mouseLocations.WORK_AREA) {
        //         rt.active.dente = null;
        //     }
        //    });

        },

        // -----------------------------------------------------------------

        MUT_runtimeUpdate_events: (state, payload) => {
            help.updateObj(state.runtime.events, payload, 
                ['jobLoaded', 'elemsLoaded', 'savePending']);
        },

        // -----------------------------------------------------------------

        MUT_uiUpdate: (state, payload) => {
            if ('colorTheme' in payload) {
                help.updateObj(state.ui, payload, ['colorTheme']);
            }
        },

        // -----------------------------------------------------------------

        MUT_uiUpdate_workArea: (state, payload) => {
            var wa = state.ui.workArea;

            if ('imgBC' in payload) {
                if ('delta' in payload.imgBC) {
                    wa.imgBC.contrast   += payload.imgBC.delta.x;
                    wa.imgBC.brightness += payload.imgBC.delta.y;                    
                } else if ('reset' in payload.imgBC) {
                    wa.imgBC.brightness = 100;
                    wa.imgBC.contrast   = 100;
                }
            }

            if ('zoom' in payload) {
                help.updateObj(wa.zoom, payload.zoom, ['scale']);
                if ('delta' in payload.zoom) {
                    wa.zoom.offset.x += payload.zoom.delta.x;
                    wa.zoom.offset.y += payload.zoom.delta.y;
                }
            }
        },

        // -----------------------------------------------------------------

        MUT_uiUpdate_toolbar: (state, payload) => {
            var toolbar = state.ui.toolbar;

            if ('toolType' in payload) {
                if (payload.toolType == toolbar.toolType && payload.toolType != gConsts.tool.attrib.types.NO_TOOL) {
                    toolbar.toolType = gConsts.tool.attrib.types.NO_TOOL;
                    toolbar.button = -1;
                    return;
                }
            } 
            
            if ('button' in payload) {
                if (payload.button == toolbar.button) {
                    toolbar.button = -1;
                    return;
                }
            }

            help.updateObj(state.ui.toolbar, payload,
                ['button', 'toolType']);
        },

        // -----------------------------------------------------------------

        MUT_uiUpdate_sidePanels: (state, payload) => {
            var sidePanels = state.ui.sidePanels;

            help.updateObj(sidePanels, payload, 
                ['activeSp', 'nodeSearchStr', 'spAnnotSide']);

            if ('activeSp' in payload) {
                if (payload.activeSp == gConsts.ui.sidePanel.ids.ANNOTS) {
                    if ('spAnnotSide' in payload) {
                        state.setup.app.sidePanels.find(panel => panel.id == gConsts.ui.sidePanel.ids.ANNOTS).side = payload.spAnnotSide; 
                    }
                }
            }                    
        },

        // -----------------------------------------------------------------

        MUT_uiUpdate_toggles: (state, payload) => {
            help.updateObj(state.ui.toggles, payload, 
                ['nodeSearch', 'crossHair', 'imgOrigin', 'clearImgView', 
                 'showToolHandles']);

            if ('crossHair' in payload) {
                utils.localStorage_setItem('ui.toggles.crossHair', payload.crossHair);
            }
        },

        // -----------------------------------------------------------------

        MUT_toolAdd: (state, payload) => {
            var serial, tool, elem,                
                rt    = state.runtime,
                nodes = state.setup.proj.nodes,
                tools = state.job.tools;
                
            elem = help.getActiveElem(state);
            serial = rt.serialCounters.tool++;
            tool = {
                id : 'tool' + '_' + payload.type + '_' + rt.active.label + '[' + serial + ']',
                attrib : {
                    type     : payload.type,
                    iAMethod : gConsts.tool.attrib.iaMethods.NONE,
                },
                label : {
                    text   : nodes.get(rt.active.label)?.layout?.label,
                    id     : rt.active.label,
                    layer  : rt.active.layer,
                    vLabel : {x: 0, y: 0},
                },
                state : {
                    confidence : gConsts.tool.state.confidence.OK,
                    marked     : false,
                    input      : gConsts.tool.state.inputs.MANUAL
                },
                elem : {
                    index : rt.active.elemIdx,
                    id    : elem.id,
                    slice : elem.img.slice
                },
                coords : {
                    pts : payload.pts,
                    ptsOriginal : null,
                },
                locations  : {
                    external : {
                        list : [],
                        custom : ''
                    },
                    internal : {
                        faces : {
                            list : [],
                            custom : ''
                        },
                        portions : {
                            list : [],
                            custom : ''
                        }
                    }
                },  // dente : (cInfo.activeDente != null) ? cInfo.activeDente.label : '',
                qualifiers : {
                    list : payload.qualifiers || [],
                    custom : ''
                },
            }
            tools.push(tool);

            // console.log('MUT_toolAdd: tool.locations: ' + (tool.locations ? Array.from(tool.locations.keys()).join(', ') : 'none'));

            rt.events.savePending = true;
            rt.active.tool = tool;
            // console.log('MUT_toolAdd: rt.active.tool: ' + JSON.stringify(rt.active.tool));
        },

        // -----------------------------------------------------------------

        MUT_toolUpdate: (state, payload) => {
            var tool,
                job = state.job,
                rt  = state.runtime,
                mov = state.runtime.mov;

            const payloadTool = job.tools.find(tool => tool.id == payload.tool_id);
            
            /* Se é a 1a vez que uma tool detectada [input == BOT] está 
                sendo manipulada, salvo os pontos originais (antes da alteração) 
                e faço [tool.input = MIXED] */            
            // if ( (tool = mov.tool                                  ) &&   // tem tool ativa sendo manipulada
            //      (tool.state.input == gConsts.tool.state.inputs.BOT) &&   // foi criada pelo BOT     
            //      (('pts' in payload) || ('delta' in payload)       ) &&   // tem (delta || pts) no payload para serem aplicados
            //      ([gConsts.mov.types.HANDLE_DRAG,
            //        gConsts.mov.types.TOOL_DRAG].includes(mov.type) ) ) {  // este (delta || pts) serao aplicados na tool
            //         tool.coords.ptsOriginal = _.cloneDeep(tool.coords.pts);
            //         tool.state.input = gConsts.tool.state.inputs.MIXED;
            // } 
            
            // if (('delta' in payload) && (payload.delta != null) 
            //     && ('tool_id' in payload) && (payload.tool_id != null)
            //     && ('drag_type' in payload) && (payloadTool != null)) {

            //     switch (payload.drag_type) {
            //         case 'handle_drag' :
            //             if ('tool_pt' in payload && payload.tool_pt != null) {
            //                 payloadTool.coords.pts[payload.tool_pt].x += payload.delta.x;
            //                 payloadTool.coords.pts[payload.tool_pt].y += payload.delta.y;
            //                 console.log("payloadTool.coords.pts[payload.tool_pt]: ", JSON.stringify(payloadTool.coords.pts[payload.tool_pt]));
            //             }
            //             break;

            //         case 'label_drag' :
            //             payloadTool.label.vLabel.x += payload.delta.x;
            //             payloadTool.label.vLabel.y += payload.delta.y;
            //             console.log("payloadTool.label.vLabel: ", JSON.stringify(payloadTool.label.vLabel));
            //             break;
            //     }

            // }

//             if (('delta' in payload) && (payload.delta != null) && mov.tool != null) {
//                 tool = mov.tool;

//                 // console.log(mov,'payload.delta: ' + JSON.stringify(payload.delta));

                

//                 switch (mov.type) {
//                     case gConsts.mov.types.TOOL_CREATION :
//                     case gConsts.mov.types.HANDLE_DRAG   :
//                         tool.coords.pts[mov.toolPt].x += payload.delta.x;
//                         tool.coords.pts[mov.toolPt].y += payload.delta.y;
//                         console.log("tool.coords.pts[mov.toolPt]: ", JSON.stringify(tool.coords.pts[mov.toolPt]));
//                         break;

//                     /* Durante o drag da tool (para ganhar desempenho) as coordenadas reais nao sao 
//                        alteradas, apenas um offset que eh usado para setar o translate do svg da tool.
//                        As coordenadas reais sao alteradas somente no mouseUp na [MUT_movUpdate] */
//                     case gConsts.mov.types.TOOL_DRAG :  
//                         mov.toolOffset.x += payload.delta.x;
//                         mov.toolOffset.y += payload.delta.y;
//                         console.log("mov.toolOffset: ", JSON.stringify(mov.toolOffset));
// //                        console.log('mov.toolOffset [x, y] : [' + mov.toolOffset.x + ', ' + mov.toolOffset.y + ']');
//                         break;

//                     case gConsts.mov.types.LABEL_DRAG :
//                         tool.label.vLabel.x += payload.delta.x;
//                         tool.label.vLabel.y += payload.delta.y;
//                         console.log("tool.label.vLabel: ", JSON.stringify(tool.label.vLabel));
//                         break;
//                 }
//             }

            if ('vLabel' in payload && (payloadTool != null)) {
                payloadTool.label.vLabel = payload.vLabel;
                // console.log('MUT_toolUpdate: tool.label.vLabel: ' + JSON.stringify(tool.label.vLabel));
            }

            if (('pts' in payload) && (payload.pts != null) && (payloadTool != null)) {
                for (const [key, value] of Object.entries(payload.pts)) {
                    payloadTool.coords.pts[key].x = value.x;
                    payloadTool.coords.pts[key].y = value.y;
                }                
            }

            if ('state' in payload && (payloadTool != null)) {
                payloadTool.state.confidence = payload.state;
            }

            if ('mark' in payload && (payloadTool != null)) {
                payloadTool.state.marked = !payloadTool.state.marked;
            }

            if ('dente' in payload && (payloadTool != null)) {
                payloadTool.dente = payload.dente;
            }

            if ( ('outerCMP' in payload) && 
                 ('innerCMP' in payload) &&
                 ('toolIdx'  in payload) ) {
                job.tools[payload.toolIdx]['outerCMP'] = payload.outerCMP;
                job.tools[payload.toolIdx]['innerCMP'] = payload.innerCMP;
            }
            
            if (!rt.events.savePending) { 
                rt.events.savePending = true; 
            }
        },

        // -----------------------------------------------------------------

        MUT_toolAddPts: (state, payload) => {
            var pts,
                addedPts = 0,
                newPts = {},
                job = state.job,
                rt = state.runtime,
                mov = state.runtime.mov;

            const payloadTool = job.tools.find(tool => tool.id == payload.tool_id);
            if (payloadTool == null)
                return;

            pts = payloadTool.coords.pts;
            // se payload nao tem 'newPts'
            if (!('newPts' in payload) && ('tool_pt' in payload)) {  
                // estamos criando uma tool e adicionando um novo ponto (duplicando o mov.toolPt na mov.tool)
                newPts[payload.tool_pt] = {
                    x : pts[payload.tool_pt].x,
                    y : pts[payload.tool_pt].y
                }
            } else if('newPts' in payload) {
                newPts = payload.newPts;
            }

            for (const [index, newPt] of Object.entries(newPts)) {
                pts.splice(parseInt(index) + addedPts, 0, newPt); // a cada ponto adicionado, index fica defasado e precisa ser padded
                addedPts++
            }
    
            rt.events.savePending = true;
        },

        // -----------------------------------------------------------------

        MUT_toolDelPts: (state, payload) => {
            var pts,
                rt = state.runtime;

            pts = rt.active.tool.coords.pts;
            payload.delPts.forEach(delPtIndex => {
                pts.splice(delPtIndex, 1);
            })

            rt.events.savePending = true;
        }, 

        // -----------------------------------------------------------------

        MUT_toolDelete: (state) => {
            var toolIdx,
                tools = state.job.tools,
                rt    = state.runtime;

            toolIdx = tools.indexOf(rt.active.tool);
            if (toolIdx > -1) {
                tools.splice(toolIdx, 1);
            }

            rt.events.savePending = true;
        },

        // -----------------------------------------------------------------

        MUT_jobToolsUpdate: (state, payload) => {
            var job = state.job,
                rt = state.runtime;

            if (payload.type == null || payload.tool == null) {
                return;
            }
            
            switch (payload.type.split('.')[0]) {
                case 'add':
                    job.tools.push(_.cloneDeep(payload.tool));
                    break;
                case 'update':
                    job.tools.forEach(tool => { 
                        if (tool.id == payload.tool.id) {
                            tool.label.vLabel = _.cloneDeep(payload.tool.label.vLabel);
                            tool.dente = payload.tool.dente;
                            tool.locations = _.cloneDeep(payload.tool.locations);
                            tool.qualifiers = _.cloneDeep(payload.tool.qualifiers);
                            tool.state.confidence = payload.tool.state.confidence;
                            tool.state.input = payload.tool.state.input;
                            tool.coords.pts = _.cloneDeep(payload.tool.coords.pts);
                        }
                    });
                    break;
                case 'delete':
                    job.tools.forEach((tool, index) => { 
                        if (tool.id == payload.tool.id) {
                            job.tools.splice(index, 1);
                        }
                    });
                    break;
            }

            console.log('MUT_jobToolsUpdate: job.tools');
        },

        // Mutations do Report Nodes -----------------------------------------------------------------

        MUT_reportNodes_addNewLabelReportText: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            if (payload.labelId == null)
                return;

            var labelReportNode = job.report.nodes.find(reportNode => reportNode.id == payload.labelId);

            if (!labelReportNode) {
                labelReportNode = help.addNewReportNode(job.report.nodes, state, payload.labelId);
                if (!labelReportNode)
                    return;
            }

            // console.log('MUT_reportNodes_addNewLabelReportText: labelReportNode: ', JSON.stringify(labelReportNode));
        },

        MUT_reportNodes_removeReportNode: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            if (payload.nodeId == null)
                return;

            help.removeReportNode(job.report.nodes, nodes, payload.nodeId);

            console.log('MUT_reportNodes_removeReportNode: nodeId: ', payload.nodeId);
        },

        MUT_reportNodes_removeEmptyReportLabels: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            var removeLines = [];
            job.report.nodes
                .filter(reportNode => [gConsts.node.layout.types.LABEL, gConsts.node.layout.types.CUSTOM_LINE].includes(reportNode.layout.type))
                .forEach(reportNode => {
                    // Se apagar todo texto do relatorio.
                    if ([null, '', '<p></p>'].includes(reportNode.reportText)) {
                        removeLines.push([reportNode.id, reportNode.layout.type]);
                        return;
                    }
                    const labelNode = nodes.get(reportNode.id);

                    if (!labelNode || !anotacaoUtils.labelHasAnnotations(labelNode.id)) {
                        return
                    }

                    if (reportNode.annotation.list.length == 0) {
                        removeLines.push([reportNode.id, reportNode.layout.type]);
                    }
                });

            console.log('MUT_reportNodes_removeEmptyReportLabels: removeLines: ', removeLines);

            for (const line of removeLines) {
                if (line[1] == gConsts.node.layout.types.LABEL) {
                    help.removeReportNode(job.report.nodes, nodes, line[0]);
                } else if (line[1] == gConsts.node.layout.types.CUSTOM_LINE) {
                    help.removeCustomReportLine(job.report.nodes, line[0]);
                }
            }

            // console.log('MUT_reportNodes_removeEmptyReportLabels: job.report.nodes: ', JSON.stringify(job.report.nodes));
        },

        MUT_reportNodes_refreshLabelAnnotations: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            if (payload.labelId == null)
                return;

            const payloadLabelNode = nodes.get(payload.labelId);
            if (payloadLabelNode == null)
                return;

            if (!anotacaoUtils.labelHasAnnotations(payload.labelId))
                return;

            // console.log('MUT_reportNodes_refreshLabelAnnotations: payloadLabelNode: ', JSON.stringify(payloadLabelNode));

            var labelReportNode = job.report.nodes.find(reportNode => reportNode.id == payload.labelId);
            var editedAnnotationIndexMap = {};

            var newLabelAnnotations = [];
            job.tools.forEach(tool => {
                // Se o annotation ja existe e foi editado, nao processo ele novamente
                if (labelReportNode) {
                    const foundAnnotationIndex = labelReportNode.annotation.list.findIndex(annotation => annotation.toolId == tool.id);
                    if (foundAnnotationIndex > -1 && labelReportNode.annotation.list[foundAnnotationIndex].edited) {
                        editedAnnotationIndexMap[tool.id] = foundAnnotationIndex;
                        newLabelAnnotations.push(labelReportNode.annotation.list[foundAnnotationIndex])
                        return;
                    }
                }
                if (payloadLabelNode.id == tool.label.id) {
                    help.addToolAnnotationForReportLabel(newLabelAnnotations, tool, state);
                }
            });

            // console.log('MUT_reportNodes_refreshLabelAnnotations: newLabelAnnotations: ', payload.labelId, JSON.stringify(newLabelAnnotations));

            // Atualiza os reportNodes com os novos locations
            if (!labelReportNode) {
                labelReportNode = help.addNewReportNode(job.report.nodes, state, payload.labelId);
                if (labelReportNode) {
                    labelReportNode.annotation.list = newLabelAnnotations;
                    reportUtils.refreshLabelAnnotationsReportText(labelReportNode);
                }
            } else {
                Object.entries(editedAnnotationIndexMap)
                    .sort((a, b) => a[1] - b[1])
                    .forEach(([toolId, index]) => {
                        // Encaixo as anotacoes editadas na mesma posicao
                        const newLabelAnnotationsIndex = newLabelAnnotations.findIndex(newAnnotation => newAnnotation.toolId == toolId);
                        newLabelAnnotations.splice(newLabelAnnotationsIndex, 1);
                        newLabelAnnotations.splice(index, 0, labelReportNode.annotation.list[index]);
                    })

                labelReportNode.annotation.list = newLabelAnnotations;
                reportUtils.refreshLabelAnnotationsReportText(labelReportNode);

                // const oldAnnotationsIds = labelReportNode.annotation.list.map(annotation => annotation.id);
                // const newAnnotationsIds = newLabelAnnotations.map(annotation => annotation.id);
                // // Se realmente não mudou nenhuma location, eu não preciso atualizar o reportNodes
                // if (oldAnnotationsIds.length != newAnnotationsIds.length || oldAnnotationsIds.some(id => !newAnnotationsIds.includes(id))) {
                //     console.log('MUT_reportNodes_refreshLabelAnnotations: updating reportNodes for label: ', payload.labelId);
                //     labelReportNode.annotation.list = newLabelAnnotations;
                //     reportUtils.refreshLabelAnnotationsReportText(labelReportNode);
                // }
            }
        },

        MUT_reportNodes_updateLabelValidation: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            if (payload.labelId == null)
                return;

            const labelReportNode = job.report.nodes.find(reportNode => reportNode.id == payload.labelId);
            if (labelReportNode == null)
                return;
            
            if (labelReportNode.layout.type != gConsts.node.layout.types.LABEL)
                return;

            labelReportNode.info.validated = payload.validated;
                
        },

        MUT_reportNodes_updateLabelAnnotation: (state, payload) => {
            var reportNodes = state.job.report.nodes;

            if (payload.labelId == null || payload.annotation == null)
                return;

            if (payload.annotation.localizacao == null || payload.annotation.qualificadores == null)
                return;

            const payloadLabelNode = reportNodes.find(reportNode => reportNode.id == payload.labelId);
            if (payloadLabelNode == null)
                return;

            const associationType = anotacaoUtils.getAssociationTypeByAnnotationType(payloadLabelNode?.annotation?.type);

            if (!payloadLabelNode.annotation.list.some(annotation => annotation.id == payload.annotation.id)) {
                const newAnnotation = new LabelAnnotation(
                    payloadLabelNode?.annotation?.type,
                    payload.annotation.toolId,
                    _.cloneDeep(payload.annotation.localizacao),
                    _.cloneDeep(payload.annotation.qualificadores)
                );
                payloadLabelNode.annotation.list.push(newAnnotation);
            }
            
            payloadLabelNode.annotation.list.forEach(annotation => {
                if (associationType == gConsts.node.report.annotation.association.GROUP || annotation.id == payload.annotation.id) {
                    const newLocalizacao = new LabelAnnotationLocation(
                        payload.annotation.localizacao.especificacao, 
                        _.cloneDeep(payload.annotation.localizacao.regioesAnatomicas || []), 
                        _.cloneDeep(payload.annotation.localizacao.dentes || []),
                        payload.annotation.localizacao.especificacaoInterna
                    );
                    annotation.update(newLocalizacao, _.cloneDeep(payload.annotation.qualificadores || []));
                }
            });

            console.log('MUT_reportNodes_updateLabelAnnotation: payloadLabelNode.annotation.list: ', JSON.stringify(payloadLabelNode.annotation.list));
        },

        MUT_reportNodes_updateLabelReportText: (state, payload) => {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            if (payload.labelId == null)
                return;

            var labelReportNode = job.report.nodes.find(reportNode => reportNode.id == payload.labelId);

            if (!labelReportNode) {
                labelReportNode = help.addNewReportNode(job.report.nodes, state, payload.labelId);
                if (!labelReportNode)
                    return;
            }

            labelReportNode.reportText = payload.text || '';

            // console.log('MUT_reportNodes_updateLabelReportText: labelReportNode: ', JSON.stringify(labelReportNode));
        },

        MUT_reportNodes_setDenticaoNode(state, payload) {
            var job = state.job,
                nodes = state.setup.proj.nodes;

            // Verifica se o nodeId é válido para denticao. Null é para desselecionar.
            if (![null, ...nodes.values().filter(node => node.layout.parent == 'layer_tipoDenticao').map(node => node.id)].includes(payload.nodeId))
                return;

            // Remove o report node já selecionado
            const selectedDenticaoReportNode = job.report.nodes.findIndex(reportNode => reportNode.layout.parent == 'layer_tipoDenticao');
            if (selectedDenticaoReportNode > -1) {
                const selectedDenticaoReportNodeId = job.report.nodes[selectedDenticaoReportNode].id;
                help.removeReportNode(job.report.nodes, nodes, selectedDenticaoReportNodeId);
                console.log('MUT_reportNodes_setDenticaoNode: job.report.nodes: removed selected denticao report node');
            }

            if (payload.nodeId == null)
                return;

            var denticaoReportNode = job.report.nodes.find(reportNode => reportNode.id == payload.nodeId);

            if (!denticaoReportNode) {
                denticaoReportNode = help.addNewReportNode(job.report.nodes, state, payload.nodeId);
                if (!denticaoReportNode)
                    return;
            }
            
            if (payload.text)
                denticaoReportNode.reportText = payload.text;

            console.log('MUT_reportNodes_setDenticaoNode: denticaoReportNode: ', JSON.stringify(denticaoReportNode));
        },

        MUT_report_addCustomLineText: (state, payload) => {
            var job = state.job;

            const customLine = help.addCustomReportLine(job.report.nodes, payload);

            if (payload.parent != null && customLine) {
                var sameLayerNodes = job.report.nodes.filter(reportNode => reportNode.layout.parent == payload.parent);
                help.refreshReportNodesOrderList(sameLayerNodes);
            }

            // console.log('MUT_report_addCustomLineText: customLine: ', JSON.stringify(job.report.nodes));

            state.runtime.report.state.lastAddedCustomLineId = customLine.id;
        },

        MUT_report_removeCustomLineText: (state, payload) => {
            var job = state.job;

            if (payload.customLineId == null)
                return;

            help.removeCustomReportLine(job.report.nodes, payload.customLineId);

            // console.log('MUT_report_removeCustomLineText: job.report.nodes: ', JSON.stringify(job.report.nodes));
        },

        MUT_report_updateCustomLineText: (state, payload) => {
            var job = state.job;

            if (payload.customLineId == null)
                return;
                
            const customLineIndex = job.report.nodes.findIndex(customLine => customLine.id == payload.customLineId);
            if (customLineIndex == -1) {
                return;
            }

            job.report.nodes[customLineIndex].reportText = payload.text;
        },

        MUT_report_updateLayerOrderList: (state, payload) => {
            var job = state.job;
            // console.log('MUT_report_updateLayerOrderList: payload: ', JSON.stringify(payload));

            if (payload.layerId == null)
                return;

            const layerChildrenNodes = job.report.nodes.filter(reportNode => reportNode.layout.parent == payload.layerId);
            if (layerChildrenNodes.length == 0)
                return;

            const orderList = payload.orderList;
            for (const [index, nodeId] of orderList.entries()) {
                const nodeReportNode = layerChildrenNodes.find(reportNode => reportNode.id == nodeId);
                if (!nodeReportNode)
                    continue;

                nodeReportNode.order.index = index;
            }

            console.log('MUT_report_updateLayerOrderList: job.report.nodes: ', JSON.stringify(job.report.nodes.filter(reportNode => reportNode.layout.parent == payload.layerId)));
        },

        /* Mutations de configuracao do report */

        MUT_report_configVisualizacao_update: (state, payload) => {
            var config = state.runtime.report.config.visualizacao;

            if (payload.config == null)
                return;

            help.updateObj(config, payload.config, ['showLabelColorSquare', 'hideLayerTitle', 'hideSectionTitle', 'removeLabelAnnotationStyle']);
        },
        
    },

    // =========================================================================================

    actions : {   
        ACT_setup: (context, payload) => {
            var appData, projData, nodes, node, 
                custom = ('custom' in payload) ? payload.custom : null,
                setup  = context.state.setup;

            appData  = apps[payload.appId];
            projData = appData.projects[payload.projId]; 

            // Só (re)carrego o app se ele já não estiver carregado  (do job anterior)
            if (payload.appId != setup.app.id) {
                payload.app = {
                    info       : appData.info,
                    id         : payload.appId,
                    toolbars   : appData.toolbars,
                    sidePanels : appData.sidePanels
                };
            }

            // Só (re)carrego o proj se ele já não estiver carregado (do job anterior)
            if (payload.projId != setup.proj.id) {
                nodes = new Map(projData.nodes.map(node => [node.id, node]));
                // console.log('[ACT_setup] nodes loaded:', nodes, 'count:', nodes.size);
                // Aplicar as customizações (primeiro as da clinica e depois do usuario)
                if (custom) {
                    custom.clinic.nodes.forEach(customNode => {
                        node = nodes.get(customNode.id);
                        _.merge(node, customNode);                    
                    });
                    custom.user.nodes.forEach(customNode => {
                        node = nodes.get(customNode.id);
                        _.merge(node, customNode);                    
                    });    
                }

                payload.proj = {
                    info   : appData.info,
                    id     : payload.projId,
                    nodes  : nodes,
                    custom : payload.custom
                };
            }

            context.commit('MUT_setup', payload);
        },

        // -----------------------------------------------------------------

        ACT_setupUpdate: (context, payload) => {
            if ('config' in payload) {
                context.commit('MUT_setupUpdate_config', payload);
            }    
        },

        // -----------------------------------------------------------------

        ACT_loadJob: (context, payload) => {
            context.commit('MUT_loadJob', payload);
        },

        // -----------------------------------------------------------------

        ACT_jobUpdate: async (context, payload) => {
            var jobSaveObj, 
                instance = context.state.setup.instance,
                job = context.state.job,
                forceSave = false,
                MUT_jobUpdate_payload = {},
                rt = context.state.runtime,
                newActiveJob = -1,
                state = -1,
                inc = 0;

            if ('control' in payload) {
                switch (payload.control) {
                    case gConsts.job.controls.DISCARD :
                        switch (job.state) {  
                            case gConsts.job.states.DISCARDED : 
                                if (confirm('Este job está descartado da instância. Tem certeza que deseja reverter essa ação ?')) {
                                    state = help.getJobState(context, gConsts.job.stateUpdates.JOB_RESET_DISCARDED);
                                }
                                break;

                            default :  // todos os outros states viram DISCARDED  
                                if (confirm('Tem certeza que deseja descartar o job corrente da instância ?')) {
                                    state = gConsts.job.states.DISCARDED;
                                }    
                        }
                        break;

                    case gConsts.job.controls.DOUBT :
                        switch (job.state) {  
                            case gConsts.job.states.DOUBT :  // se o job.state estava em DOUBT
                                state = help.getJobState(context, gConsts.job.stateUpdates.JOB_RESET_DOUBT);
                                break;  

                            case gConsts.job.states.DIVERGENT :  // se o job.state estava em DIVERGENT ou DISCARDED
                            case gConsts.job.states.DISCARDED :
                                break;  // state permanece inalterado pois estes states tem precedencia

                            default :  // todos os outros states viram DOUBT 
                                state = gConsts.job.states.DOUBT;  
                        }
                        break;

                    case gConsts.job.controls.BACK :
                        inc = -1;
                        break;

                    case gConsts.job.controls.SKIP :
                        inc = 1;
                        break;

                    case gConsts.job.controls.CONFIRM :
                        state = gConsts.job.states.CONFIRMED;
                        forceSave = true;
                        inc = 1;
                        break;    
                }
                newActiveJob = rt.active.jobIdx + inc;
                if (state != -1) {
                    MUT_jobUpdate_payload['state'] = state;
                }
            } else if ('index' in payload) {
                newActiveJob = payload.index;
            }
            if ('label' in payload) {
                MUT_jobUpdate_payload['label'] = payload.label;
            }
        
            context.commit('MUT_jobUpdate', MUT_jobUpdate_payload);

            if (rt.events.savePending || forceSave) {
//                 jobSaveObj = help.jobSaveObj(job, context.getters.GET_jobTools);
//                 jobSaveObj.token = localStorage.getItem('auth')
// //                console.log('Teste await ')
//                 let response = await utils.saveJob(gConsts.setup.io.server + gConsts.setup.io.reqs.SAVE_JOB, jobSaveObj, instance.name)
                // DEFINIR FUNÇÃO PARA SALVAR O JOB
                //  let response = await utils.saveJob(gConsts.setup.io.server + gConsts.setup.io.reqs.SAVE_JOB, job, instance.name)
                

                // if(!response){
                //     return false;
                // }
                context.commit('MUT_runtimeUpdate_events', { 'savePending' : false });
            }

            if ( (newActiveJob != -1                   ) &&
                 (newActiveJob != rt.active.jobIdx     ) && 
                 (newActiveJob != instance.jobs.length ) ) {

                context.dispatch('ACT_runtimeUpdate', { 'active' : { 'jobIdx' : newActiveJob } });
            }
        },

        // -----------------------------------------------------------------

        ACT_runtimeUpdate: (context, payload) => {
            var newActiveJob;

            // console.log('[ACT_runtimeUpdate] payload: ' + JSON.stringify(payload));

            if ('execMode' in payload) {
                context.commit('MUT_runtimeUpdate', payload );
            }    

            if ('mov' in payload) {
               profiler.profileBlock('Mutation', 'Store.ACT_runtimeUpdate', 'MUT_runtimeUpdate_mov', () => {
                context.commit('MUT_runtimeUpdate_mov', payload.mov);
               });
            }

            if ('active' in payload) {
               profiler.profileBlock('Mutation', 'Store.ACT_runtimeUpdate', 'MUT_runtimeUpdate_active', () => {
                context.commit('MUT_runtimeUpdate_active', payload.active);
               });

                if ('jobIdx' in payload.active) {
                    newActiveJob = context.state.instance.jobs[payload.active.jobIdx];
                    context.commit('MUT_loadJob', newActiveJob);
                    help.setJobMetrics(context.state);
                }
            }

            if ('events' in payload) {
                context.commit('MUT_runtimeUpdate_events', payload.events);
            }
        },

        // -----------------------------------------------------------------

        ACT_uiUpdate: (context, payload) => {
            if ('colorTheme' in payload) {
                context.commit('MUT_uiUpdate', payload);
            }

            if ('workArea' in payload) {
                context.commit('MUT_uiUpdate_workArea', payload.workArea);
            }

            if ('toolbar' in payload) {
                context.commit('MUT_uiUpdate_toolbar', payload.toolbar);
            }

            if ('sidePanels' in payload) {
                context.commit('MUT_uiUpdate_sidePanels', payload.sidePanels);

                if (payload.sidePanels.activeSp != '') {
                    evtBus.$emit('evt_panelActivation', payload.sidePanels.activeSp);
                }
            }

            if ('toggles' in payload) {
                context.commit('MUT_uiUpdate_toggles', payload.toggles);
            }
        },

        // -----------------------------------------------------------------

        ACT_toolAdd: (context, payload) => {
            context.commit('MUT_toolAdd', payload);
            help.updateJobState(context, gConsts.job.stateUpdates.TOOL_ADD);
        },

        // -----------------------------------------------------------------

        ACT_toolUpdate: (context, payload) => {
            var event = gConsts.job.stateUpdates.TOOL_UPDATE_OTHER;
            
            context.commit('MUT_toolUpdate', payload);
            if ('state' in payload) {
                event = gConsts.job.stateUpdates.TOOL_UPDATE_STATE;
            }
            help.updateJobState(context, event);
        },

        // -----------------------------------------------------------------

        ACT_toolAddPts: (context, payload) => {
            context.commit('MUT_toolAddPts', payload);
            help.updateJobState(context, gConsts.job.stateUpdates.TOOL_ADD_PTS);
        },

        // -----------------------------------------------------------------

        ACT_toolDelPts: (context, payload) => {
            if (('delPts' in payload) && (payload.delPts.length != 0)) {
                context.commit('MUT_toolDelPts', payload);
                help.updateJobState(context, gConsts.job.stateUpdates.TOOL_DEL_PTS);
            }
        },

        // -----------------------------------------------------------------

        ACT_toolDelete: (context) => {      
            var tools, newActiveTool,
                rt  = context.state.runtime,
                mov = context.state.runtime.mov;

            if ((rt.active.tool != null) && (mov.type != gConsts.mov.types.TOOL_CREATION)) {                
                context.commit('MUT_toolDelete', { addUndoState : true });
                help.updateJobState(context, gConsts.job.stateUpdates.TOOL_DELETE);

                tools = context.getters.GET_activeLayerTools;
                newActiveTool = (tools.length > 0) ? tools[tools.length - 1] : null;
                context.commit('MUT_runtimeUpdate_active', { tool : newActiveTool });
            }
        },

        ACT_jobToolsUpdate: (context, payload) => {
            context.commit('MUT_jobToolsUpdate', payload);

            switch (payload.type) {
                case 'add':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_ADD);
                    break;
                case 'update':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_UPDATE_OTHER);
                    break;
                case 'update.state':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_UPDATE_STATE);
                    break;
                case 'update.add_pts':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_ADD_PTS);
                    break;
                case 'update.delete_pts':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_DEL_PTS);
                    break;
                case 'delete':
                    help.updateJobState(context, gConsts.job.stateUpdates.TOOL_DELETE);
                    break;
            }

            // console.log('ACT_jobToolsUpdate: payload.tool?.label?.id: ', JSON.stringify(payload.tool));
            context.dispatch('ACT_reportNodes_refreshLabelAnnotations', { labelId : payload.tool?.label?.id });
        },

        // Ações do Report Nodes -----------------------------------------------------------------
        
        ACT_reportNodes_addNewLabelReportText: (context, payload) => {
            // console.log('ACT_reportNodes_addNewLabelReportText: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_addNewLabelReportText', payload);
            context.commit('MUT_reportNodes_refreshLabelAnnotations' , { labelId : payload.labelId });
        },

        ACT_reportNodes_removeReportNode: (context, payload) => {
            console.log('ACT_reportNodes_removeReportNode: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_removeReportNode', payload);
        },

        ACT_reportNodes_removeEmptyReportLabels: (context, payload) => {
            // console.log('ACT_reportNodes_removeEmptyReportLabels: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_removeEmptyReportLabels', payload);
        },

        ACT_reportNodes_refreshLabelAnnotations: (context, payload) => {
            console.log('ACT_reportNodes_refreshLabelAnnotations: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_refreshLabelAnnotations', payload);
        },

        ACT_reportNodes_updateLabelAnnotation: (context, payload) => {
            console.log('ACT_reportNodes_updateLabelAnnotation: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_updateLabelAnnotation', payload);
            context.dispatch('ACT_reportNodes_refreshLabelAnnotations', { labelId : payload.labelId });
        },

        ACT_reportNodes_updateLabelValidation: (context, payload) => {
            console.log('ACT_reportNodes_updateLabelValidation: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_updateLabelValidation', payload);
        },

        ACT_reportNodes_updateLabelReportText: (context, payload) => {
            // console.log('ACT_reportNodes_updateLabelReportText: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_updateLabelReportText', payload);
        },

        ACT_reportNodes_setDenticaoNode: (context, payload) => {
            console.log('ACT_reportNodes_setDenticaoNode: payload: ', JSON.stringify(payload));
            context.commit('MUT_reportNodes_setDenticaoNode', payload);
        },

        ACT_report_addCustomLineText: (context, payload) => {
            console.log('ACT_report_addCustomLineText: payload: ', JSON.stringify(payload));
            context.commit('MUT_report_addCustomLineText', payload);
            return context.state.runtime.report.state.lastAddedCustomLineId;
        },

        ACT_report_removeCustomLineText: (context, payload) => {
            console.log('ACT_report_removeCustomLineText: payload: ', JSON.stringify(payload));
            context.commit('MUT_report_removeCustomLineText', payload);
        },

        ACT_report_updateCustomLineText: (context, payload) => {
            console.log('ACT_report_updateCustomLineText: payload: ', JSON.stringify(payload));
            context.commit('MUT_report_updateCustomLineText', payload);
        },

        ACT_report_updateLayerOrderList: (context, payload) => {
            console.log('ACT_report_updateLayerOrderList: payload: ', JSON.stringify(payload));
            context.commit('MUT_report_updateLayerOrderList', payload);
        },

        /* Ações de configuracao do report */

        ACT_report_configVisualizacao_update: (context, payload) => {
            console.log('ACT_report_configVisualizacao_update: payload: ', JSON.stringify(payload));
            context.commit('MUT_report_configVisualizacao_update', payload);
        },
    }
})


/* 
 * =====================================================================================================
 * ---- HELPER FUNCTIONS -------------------------------------------------------------------------------
 * ===================================================================================================== 
 */

const help = {
    /**
     * @param {ReportNode[]} reportNodesList 
     * @returns {void}
     */
    refreshReportNodesOrderList(reportNodesList) {

        console.log('refreshReportNodesOrderList: reportNodesList: ', JSON.stringify(reportNodesList.map(node => [node.id, node.order.index, node.layout.type])));
        const newOrderList = reportNodesList.sort((a, b) => {
            // If same index, place the custom line after the normal node
            if (a.order.index == b.order.index) {
                if (a.isCustomLine) {
                    return 1;
                } else {
                    return -1;
                }
            }
            return a.order.index - b.order.index;
        }).map(node => node.id);

        console.log('refreshReportNodesOrderList: newOrderList: ', JSON.stringify(newOrderList));
        
        for (const [index, nodeId] of newOrderList.entries()) {
            const nodeReportNode = reportNodesList.find(reportNode => reportNode.id == nodeId);
            if (!nodeReportNode)
                continue;

            nodeReportNode.order.index = index;
        }
    },
    /**
     * @param {ReportNode[]} currentReportNodes
     * @param {string} customLineId
     * @returns {void}
     */
    removeCustomReportLine(currentReportNodes, customLineId) {
        if (customLineId == null)
            return;

        const customLineIndex = currentReportNodes.findIndex(customLine => customLine.id == customLineId);
        if (customLineIndex == -1)
            return;

        const removedCustomLine = currentReportNodes[customLineIndex];

        const siblingCustomLines = currentReportNodes.filter(customLine => customLine.layout.parent == removedCustomLine.layout.parent);
        
        currentReportNodes.splice(customLineIndex, 1);
        
        help.refreshReportNodesOrderList(siblingCustomLines);
    },
    /**
     * @param {ReportNode[]} currentReportNodes
     * @param {Object} payload
     * @returns {ReportNode | null}
     */
    addCustomReportLine(currentReportNodes, payload) {
        if (payload.orderIndex == null)
            return null;

        const id = 'customLine_' + utils.generateRandomId();
        const customReportLine = new ReportNode(id, {
                index: payload.orderIndex || 0,
            }, {
                parent: payload.parent || null,
                type: gConsts.node.layout.types.CUSTOM_LINE,
                color: '#cccccc',
                caption: ''
            }, {
                type: null,
                list: []
            },
            payload.text || ''
        )

        currentReportNodes.push(customReportLine);

        return customReportLine;
    },
    /**
     * @param {LabelAnnotation[]} currentLabelAnnotations
     * @param {object} tool
     * @param {object} state
     */
    addToolAnnotationForReportLabel(currentLabelAnnotations, tool, state) {
        var nodes = state.setup.proj.nodes,
            nodesArray = state.setup.proj.nodesArray;

        const labelNode = nodes.get(tool.label.id);
        if (!labelNode)
            return;
        if (!anotacaoUtils.labelHasAnnotations(labelNode.id))
            return;

        const labelAnnotationType = anotacaoUtils.getLabelAnnotationTypeById(labelNode.id);
        const localizacaoInternaInfo = anotacaoUtils.getLocalizacaoInternaInfoByLabelId(labelNode.id);
        const labelAssociationType = anotacaoUtils.getAssociationTypeByAnnotationType(labelAnnotationType);

        // console.log('addToolAnnotationForReportLabel: labelAnnotationType: ', labelNode.id, labelAnnotationType);


        if (tool.attrib.type != gConsts.tool.attrib.types.PONTO)
            return;

        const activeElem = help.getActiveElem(state);
        if (activeElem == null)
            return;

        var newAnnotation;

        if (labelAssociationType == gConsts.node.report.annotation.association.GROUP && currentLabelAnnotations.length > 0) {
            newAnnotation = _.cloneDeep(currentLabelAnnotations[0]);
            newAnnotation.setToolId(tool.id);
            newAnnotation.refreshReportText();
            console.log('addToolAnnotationForReportLabel: association.GROUP: newAnnotation: ', JSON.stringify(newAnnotation));
            currentLabelAnnotations.push(newAnnotation);
            return;
        }

        const getAvailableInternalLocations = (localizacaoInternaInfo) => {
            const availableFaces = (localizacaoInternaInfo?.localizacao?.face?.lista || [])
                .map(face => `${localizacaoInternaInfo?.localizacao?.face?.tipo}__${face}`);
            const availablePorcoes = (localizacaoInternaInfo?.localizacao?.porcao?.lista || [])
                .map(porcao => `${localizacaoInternaInfo?.localizacao?.porcao?.tipo}__${porcao}`);

            return {
                faces: availableFaces,
                porcoes: availablePorcoes
            }
        }

        if (labelAnnotationType == gConsts.node.report.annotation.types.TOOTH) {
            if (tool.dente != null) {

                const denteNode = nodes.get(tool.dente);
                const color = gConsts.ui.prettyColors[denteNode?.layout?.color?.toLowerCase()] || denteNode?.layout?.color;
                const availableLocations = getAvailableInternalLocations(localizacaoInternaInfo);
                const annotationFaces = (tool.locations.internal?.faces?.list || []).filter(face => availableLocations.faces.includes(face));
                const annotationPorcoes = (tool.locations.internal?.portions?.list || []).filter(porcao => availableLocations.porcoes.includes(porcao));

                newAnnotation = new LabelAnnotation(
                    labelAnnotationType,
                    tool.id,
                    new LabelAnnotationLocation(
                        tool.locations.especificacao || null,
                        [],
                        [
                            {
                                id: tool.dente,
                                text: reportUtils.getNodeReportText(denteNode),
                                color: color,
                                faces: annotationFaces,
                                porcoes: annotationPorcoes
                            }
                        ],
                        localizacaoInternaInfo?.localizacao?.especificacao
                    ),
                    []
                )
                
            }
        } else if (labelAnnotationType == gConsts.node.report.annotation.types.ANAT_ONLY) {
            const labelNodesRegiaoAnatomica = nodesArray.filter(node => node.layout?.parent == 'layer_regioesAnat').map(node => node.id);
            const regioesAnatomicas = tool.locations.external.list.filter(location => labelNodesRegiaoAnatomica.includes(location));
            if (regioesAnatomicas.length == 0)
                return;

            newAnnotation = new LabelAnnotation(
                labelAnnotationType,
                tool.id,
                new LabelAnnotationLocation(
                    tool.locations.especificacao || null,
                    regioesAnatomicas.map(regiao => {
                        const regiaoNode = nodes.get(regiao);
                        const color = gConsts.ui.prettyColors[regiaoNode?.layout?.color?.toLowerCase()] || regiaoNode?.layout?.color;
                        
                        return {
                            id: regiao,
                            text: reportUtils.getNodeReportText(regiaoNode),
                            color: color,
                            porcoes: (tool.locations.internal?.portions?.list || [])
                        }
                    }),
                   []
                ),
                []
            )

        } else if (labelAnnotationType == gConsts.node.report.annotation.types.FIXED) {
            // Faz nada. Fixed nao tem anotacoes.
        } else if (labelAnnotationType == gConsts.node.report.annotation.types.RX_SIDE) {

            const grupoEspecificacao = anotacaoUtils.getEspecificacaoGrupoByLabelId(labelNode.id);

            const tipoEspecificacao = grupoEspecificacao?.tipo || gConsts.elem.location.especificacao.group.types.LADO;
    
            // Busca o lado que o tool se encontra na imagem
            const toolElemSide = help.getToolElemSide(tool, activeElem);
            if (toolElemSide == null)
                return;

            const location_to_especificacao = {
                [gConsts.elem.location.types.LEFT]: {
                    [gConsts.elem.location.especificacao.group.types.DESVIO]: gConsts.elem.location.especificacao.desvio.PARA_ESQUERDA,
                    [gConsts.elem.location.especificacao.group.types.LADO]: gConsts.elem.location.especificacao.lado.ESQUERDO,
                },
                [gConsts.elem.location.types.RIGHT]: {
                    [gConsts.elem.location.especificacao.group.types.DESVIO]: gConsts.elem.location.especificacao.desvio.PARA_DIREITA,
                    [gConsts.elem.location.especificacao.group.types.LADO]: gConsts.elem.location.especificacao.lado.DIREITO,
                },
            }
            const especificacao = tool.locations.especificacao || location_to_especificacao[toolElemSide][tipoEspecificacao];

            if (especificacao == null)
                return;

            newAnnotation = new LabelAnnotation(
                labelAnnotationType,
                tool.id,
                new LabelAnnotationLocation(
                    especificacao,
                    [],
                    []
                ),
                []
            )

        } else if (labelAnnotationType == gConsts.node.report.annotation.types.RTOOTH) {
            // Busca as regioes dos dentes
            const regioesDentes = tool.locations.regions.list.filter(location => location.startsWith('lb_dente'));
            if (regioesDentes.length == 0)
                return;

            const availableLocations = getAvailableInternalLocations(localizacaoInternaInfo);
            const annotationFaces = (tool.locations.internal?.faces?.list || []).filter(face => availableLocations.faces.includes(face));
            const annotationPorcoes = (tool.locations.internal?.portions?.list || []).filter(porcao => availableLocations.porcoes.includes(porcao));

            newAnnotation = new LabelAnnotation(
                labelAnnotationType,
                tool.id,
                new LabelAnnotationLocation(
                    tool.locations.especificacao,
                    [],
                    regioesDentes.map(dente => {
                        const denteNode = nodes.get(dente);
                        const denteColor = gConsts.ui.prettyColors[denteNode?.layout?.color?.toLowerCase()] || denteNode?.layout?.color;
                        return {
                            id: dente,
                            text: reportUtils.getNodeReportText(denteNode),
                            color: denteColor,
                            faces: annotationFaces,
                            porcoes: annotationPorcoes
                        }
                    }),
                    localizacaoInternaInfo?.localizacao?.especificacao
                ),
                []
            )

        } else if (labelAnnotationType == gConsts.node.report.annotation.types.ANAT_RTOOTH) {
            // Busca a regiao anatomica
            const labelNodesRegiaoAnatomica = nodesArray.filter(node => node.layout?.parent == 'layer_regioesAnat').map(node => node.id);
            const regiaoAnatomica = tool.locations.external.list.find(location => labelNodesRegiaoAnatomica.includes(location));
            // Se nao tiver regiao anatomica associada nao conta como anotacao
            if (regiaoAnatomica == null)
                return;
            const regioesDentes = tool.locations.regions.list.filter(location => location.startsWith('lb_dente'));
            
            const regiaoNode = nodes.get(regiaoAnatomica);
            const regiaoColor = gConsts.ui.prettyColors[regiaoNode?.layout?.color?.toLowerCase()] || regiaoNode?.layout?.color;
            const availableInternalLocations = getAvailableInternalLocations(localizacaoInternaInfo);
            const annotationInternalFaces = (tool.locations.internal?.faces?.list || []).filter(face => availableInternalLocations.faces.includes(face));
            const annotationInternalPorcoes = (tool.locations.internal?.portions?.list || []).filter(porcao => availableInternalLocations.porcoes.includes(porcao));

            newAnnotation = new LabelAnnotation(
                labelAnnotationType,
                tool.id,
                new LabelAnnotationLocation(
                    tool.locations.especificacao,
                    [
                        {
                            id: regiaoAnatomica,
                            text: reportUtils.getNodeReportText(regiaoNode),   
                            color: regiaoColor,
                            porcoes: []
                        }
                    ],
                    regioesDentes.map(dente => {
                        const denteNode = nodes.get(dente);
                        const denteColor = gConsts.ui.prettyColors[denteNode?.layout?.color?.toLowerCase()] || denteNode?.layout?.color;
                        return {
                            id: dente,
                            text: reportUtils.getNodeReportText(denteNode),
                            color: denteColor,
                            faces: annotationInternalFaces,
                            porcoes: annotationInternalPorcoes
                        }
                    }),
                    localizacaoInternaInfo?.localizacao?.especificacao
                ),
                []
            )

        } else if (labelAnnotationType == gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH) {
            // Busca a regiao anatomica
            const labelNodesRegiaoAnatomica = nodesArray.filter(node => node.layout?.parent == 'layer_regioesAnat').map(node => node.id);
            const regiaoAnatomica = tool.locations.external.list.find(location => labelNodesRegiaoAnatomica.includes(location));

            // Busca as regioes dos dentes
            const regioesDentes = tool.locations.regions.list.filter(location => location.startsWith('lb_dente'));

            // Considera apenas se tiver regiao anatomica ou regioes de dentes proximos
            if (regioesDentes.length == 0 && regiaoAnatomica == null)
                return;

            const availableInternalLocations = getAvailableInternalLocations(localizacaoInternaInfo);
            const annotationInternalFaces = (tool.locations.internal?.faces?.list || []).filter(face => availableInternalLocations.faces.includes(face));
            const annotationInternalPorcoes = (tool.locations.internal?.portions?.list || []).filter(porcao => availableInternalLocations.porcoes.includes(porcao));
            
            const regiaoNode = nodes.get(regiaoAnatomica);
            const regiaoColor = gConsts.ui.prettyColors[regiaoNode?.layout?.color?.toLowerCase()] || regiaoNode?.layout?.color;
            
            let especificacao = tool.locations.especificacao;
            if (!especificacao) {
                especificacao = (regioesDentes.length > 0 ? 'situacao__proximo_regiao_dente' : 'situacao__proximo_regiao_anatomica');
            }
            newAnnotation = new LabelAnnotation(
                labelAnnotationType,
                tool.id,
                new LabelAnnotationLocation(
                    especificacao,
                    regiaoAnatomica ? [
                        {
                            id: regiaoAnatomica,
                            color: regiaoColor,
                            text: reportUtils.getNodeReportText(regiaoNode),
                            porcoes: []
                        }
                    ] : [],
                    regioesDentes.map(dente => {
                        const denteNode = nodes.get(dente);
                        const denteColor = gConsts.ui.prettyColors[denteNode?.layout?.color?.toLowerCase()] || denteNode?.layout?.color;
                        return {
                            id: dente,
                            text: reportUtils.getNodeReportText(denteNode),
                            color: denteColor,
                            faces: annotationInternalFaces,
                            porcoes: annotationInternalPorcoes
                        }
                    }),
                    localizacaoInternaInfo?.localizacao?.especificacao
                ),
                []
            )
        }

        if (newAnnotation) {
            // console.log('addToolAnnotationForReportLabel: newAnnotation: ', JSON.stringify(newAnnotation));
            currentLabelAnnotations.push(newAnnotation);
        }

        return currentLabelAnnotations;
    },
    getToolElemSide(tool, elem) {
        if (!tool || !elem)
            return null;
        if (tool.attrib.type != gConsts.tool.attrib.types.PONTO)
            return null;

        const toolPos = tool.coords.pts[0];
        const toolPosX = toolPos.x;
        const elemWidth = elem.dim.width;
        // A direita da panoramica é a esquerda do paciente e vice-versa
        return toolPosX < elemWidth / 2 ? gConsts.elem.location.types.RIGHT : gConsts.elem.location.types.LEFT;
    },
    /**
     * @param {ReportNode[]} currentReportNodes
     * @param {Object} nodes
     * @param {string} nodeId
     */
    removeReportNode(currentReportNodes, nodes, nodeId) {
        
        const removeNode = nodes.get(nodeId);

        if (!removeNode)
            return;

        const removeReportNodeIndex = currentReportNodes.findIndex(reportNode => reportNode.id == nodeId);

        if (removeReportNodeIndex == -1)
            return;

        // console.log("Removing report node:", nodeId, "index:", removeReportNodeIndex)

        currentReportNodes.splice(removeReportNodeIndex, 1);

        // Adiciona todos os parents do label node até o root
        var parentId = removeNode?.layout?.parent;
        // Se os parents do labelNode nao tiver nenhum outro filho no relatorio, removo junto
        var siblingReportNodes = currentReportNodes.filter(reportNode => reportNode.layout.parent == parentId && reportNode.id != nodeId);
        while (parentId && parentId != gConsts.node.layout.parents.ROOT && siblingReportNodes.length == 0) {
            var parentReportNodeIndex = currentReportNodes.findIndex(reportNode => reportNode.id == parentId);
            if (parentReportNodeIndex == -1)
                break;
            
            const parentNode = nodes.get(parentId);
            if (!parentNode)
                break;

            // console.log("-- Removing parent report node:", parentId)
            currentReportNodes.splice(parentReportNodeIndex, 1);
            parentId = parentNode?.layout?.parent;
            siblingReportNodes = currentReportNodes.filter(reportNode => reportNode.layout.parent == parentId && reportNode.id != parentNode?.id);
        }
    },
    /**
     * 
     * @param {ReportNode[]} currentReportNodes 
     * @param {Object} state 
     * @param {string} nodeId 
     * @param {'manual' | 'auto'} insertionType
     * @returns {ReportNode | null}
     */
    addNewReportNode(currentReportNodes, state, nodeId, insertionType = 'manual') {
        var sameLayerNodes = [],
            nodes = state.setup.proj.nodes,
            nodesArray = state.setup.proj.nodesArray || (Array.from(state.setup.proj.nodes?.values() || []));

        const addNode = nodes.get(nodeId);

        if (!addNode)
            return null;

        // console.log('addNewReportNode: addNode: ', addNode);
        var isLabelNode = addNode.layout.type == gConsts.node.layout.types.LABEL;

        if (isLabelNode && ![gConsts.node.report.types.LOCATION_LIST, gConsts.node.report.types.SELECT_ITEM, gConsts.node.report.types.TEXT].includes(addNode.report.type)) {
            return null;
        }

        var orderIndex = -1;
        if (isLabelNode) {
            sameLayerNodes = currentReportNodes
                .filter(reportNode => reportNode.layout.parent == addNode.layout.parent)
                .sort((a, b) => a.order.index - b.order.index);
            orderIndex = sameLayerNodes.length > 0 ? sameLayerNodes[sameLayerNodes.length - 1].order.index + 1 : 0;
        }

        const labelAnnotationType = anotacaoUtils.getLabelAnnotationTypeById(nodeId);

        // console.log('addNewReportNode: labelAnnotationType: ', addNode.id, labelAnnotationType);

        const newReportNode = new ReportNode(nodeId, {
                index: orderIndex
            }, {
                parent: addNode?.layout?.parent,
                type: addNode?.layout?.type,
                color: addNode?.layout?.color,
                caption: addNode?.layout?.caption,
            }, {
                type: labelAnnotationType,
                list: []
            }, 
            reportUtils.getInitialReportText(addNode),
            {
                insertionType: insertionType,
                validated: insertionType == 'manual'
            }
        );

        currentReportNodes.push(newReportNode);
        // console.log("Adding new label report node:", nodeId)

        // Adiciona todos os parents do label node até o root
        var parentId = addNode?.layout?.parent;
        while (parentId && parentId != gConsts.node.layout.parents.ROOT) {
            var parentReportNode = currentReportNodes.find(reportNode => reportNode.id == parentId);
            if (parentReportNode)
                break;
            
            const parentNode = nodes.get(parentId);
            if (!parentNode)
                break;

            orderIndex = -1;
            if (parentNode.layout.type == gConsts.node.layout.types.STEP) { 
                const stepOrderById = ['step_denticao', 'step_procs', 'step_achados', 'step_livre'];
                orderIndex = stepOrderById.indexOf(parentNode.id);
            } else {
                const siblingReportNodes = currentReportNodes.filter(reportNode => reportNode.layout.parent == parentNode.layout.parent)
                    .sort((a, b) => a.order.index - b.order.index);
                orderIndex = siblingReportNodes.length > 0 ? siblingReportNodes[siblingReportNodes.length - 1].order.index + 1 : 0;
            }

            const newParentReportNode = new ReportNode(
                parentNode.id, 
                {
                    index: orderIndex
                }, {
                    parent: parentNode?.layout?.parent,
                    type: parentNode?.layout?.type,
                    caption: parentNode?.layout?.caption,
                }, {
                    type: null,
                    list: []
                }, 
                reportUtils.getNodeReportText(parentNode) || parentNode?.layout.caption || ''
            );

            currentReportNodes.push(newParentReportNode);
            // console.log("-- Added parent report node:", parentId)
            parentId = parentNode?.layout?.parent;
        }
        
        return newReportNode;
    },
    updateObj(obj, payload, props) {
        if (!payload) return;

        props.forEach(prop => {
            if (prop in payload) {
                if (obj[prop] != payload[prop]) {
                    // console.log(`updateObj: ${prop} changed from ${JSON.stringify(obj[prop])} to ${JSON.stringify(payload[prop])}`);
                    obj[prop] = payload[prop]
                }
            }
        });
    },

    // -----------------------------------------------------------------

    jobSaveObj(job) {        
        //var toolObj, oldToolData;
        //     imgObj = {
        //         fullPathName : img.fullPathName,
        //         imgOrigin    : img.imgOrigin,
        //         state        : img.state,
        //         labels       : img.labels,
        //         tools : []
        //     }

        // jobTools.forEach(tool => {
        //     toolObj = {
        //         labelId  : tool.labelId,
        //         iaMethod : tool.iaMethod,
        //         type     : tool.attrib.type,
        //         label    : tool.label,
        //         state    : tool.state,
        //         layer    : tool.layer,
        //         origin   : tool.origin,
        //         marked   : tool.marked,
        //         dente    : tool.dente,
        //         pts      : tool.coords.pts
        //     }
        //     imgObj.tools.push(toolObj);
        // })

        return job;
    },

    // -----------------------------------------------------------------

    setJobMetrics(state) {
        var hasTeethLE, hasTeethSEG, hasAnatPts, 
            toothSegBBox, cRebAlvSup,
            nodes   = state.setup.proj.nodes,
            tools   = state.job.tools,
            metrics = state.job.metrics,
            metricsCalc = {
                teethLE : {
                    sum   : 0,
                    count : 0,
                },
                teethWidth : {
                    sum   : 0,
                    count : 0,
                },
                teethHeight : {
                    sum   : 0,
                    count : 0,
                }
            };

        hasTeethLE  = nodes.has(gConsts.layer.locations.TEETH_LE);
        hasTeethSEG = nodes.has(gConsts.layer.locations.TEETH_SEG);
        hasAnatPts  = nodes.has(gConsts.layer.locations.ANAT_PTS);

        if (hasTeethLE || hasTeethSEG || hasAnatPts) {
            tools.forEach(tool => {
                if ( (hasTeethLE                                          ) && 
                     (tool.label.layer == gConsts.layer.locations.TEETH_LE) && 
                     (tool.attrib.type == gConsts.tool.attrib.types.RETA  ) ) {
                    metricsCalc.teethLE.sum += Victor.fromObject(tool.coords.pts[0]).subtract(Victor.fromObject(tool.coords.pts[1])).length();
                    metricsCalc.teethLE.count += 1;                
                }

                if (hasTeethSEG && (tool.label.layer == gConsts.layer.locations.TEETH_SEG)) {
                    toothSegBBox = utils.getBoundingRect(tool.coords.pts);
                    metricsCalc.teethWidth.sum   += toothSegBBox.width;
                    metricsCalc.teethWidth.count += 1;

                    metricsCalc.teethHeight.sum   += toothSegBBox.height;
                    metricsCalc.teethHeight.count += 1;                    
                }
            });

            if (hasTeethLE) {
                metrics.teeth.meanLE = (metricsCalc.teethLE.count > 0)
                    ? metricsCalc.teethLE.sum / metricsCalc.teethLE.count
                    : 0
            }

            if (hasTeethSEG) {
                metrics.teeth.meanWidth = (metricsCalc.teethWidth.count > 0) 
                    ? metricsCalc.teethWidth.sum / metricsCalc.teethWidth.count
                    : 0
                metrics.teeth.meanHeight = (metricsCalc.teethHeight.count > 0) 
                    ? metricsCalc.teethHeight.sum / metricsCalc.teethHeight.count
                    : 0
            }            

            // O Width do rebordo alveolar superior é uma aproximação que por eqto vai servir ... UEI!!!
            if (hasAnatPts) {
                cRebAlvSup = utils.findToolByLabelId(tools, 'lb_cRebAlvSup');
                metrics.arch.width = (cRebAlvSup)
                    ? utils.getBoundingRect(cRebAlvSup.coords.pts).width
                    : 0
            }
        }

        return metrics;
    },

    // -----------------------------------------------------------------
    
    getLeMean(tools) {
        var leCount = 0,
            leSum   = 0;

        tools.forEach(tool => {
            if ((tool.label.layer == gConsts.layer.locations.TEETH_LE) && (tool.attrib.type == gConsts.tool.attrib.types.RETA)) {
                leSum += Victor.fromObject(tool.coords.pts[0]).subtract(Victor.fromObject(tool.coords.pts[1])).length();
                leCount += 1;
            }            
        });

        return (leCount != 0) ? leSum/leCount : 0;
    },

    // -----------------------------------------------------------------

    getActiveElem(state) {
        return state.job.elems[state.runtime.active.elemIdx];
    },

    // -----------------------------------------------------------------

    updateJobState(context, event) {
        var newState = help.getJobState(context, event);
        if (newState != -1) {
            context.commit('MUT_jobUpdate', { state : newState });
        }
    },

    // -----------------------------------------------------------------

    getJobState(context, event) {
        var i, 
            job      = context.state.job,      
            tools    = context.state.job.tools,
            newState = -1;

        switch (event) {
            case gConsts.job.stateUpdates.TOOL_ADD :
                // Se a [job.state == DOUBT || DIVERGENT] adicionar uma tool nao muda nada
                if ([gConsts.job.states.EMPTY, 
                     gConsts.job.states.CONFIRMED].includes(job.state)) {
                    newState = gConsts.job.states.PARTIAL;
                }
                break;

            case gConsts.job.stateUpdates.TOOL_UPDATE_OTHER : 
            case gConsts.job.stateUpdates.TOOL_ADD_PTS      : 
            case gConsts.job.stateUpdates.TOOL_DEL_PTS      : 
                /* manipulacoes da tool so mudam o job.state se ele jah estava CONFIRMED (lembrando que 
                   [job.state == EMPTY] nao pode ter manipulacoes de tools) pq ele nao tem tools para 
                   serem manipuladas) */
                if (job.state == gConsts.job.states.CONFIRMED) {
                    newState = gConsts.job.states.PARTIAL;
                }
                break;

            // toolDelete, change na tool.state e certas changes do job.state, dispara um reset do job.state
            case gConsts.job.stateUpdates.TOOL_DELETE         : 
            case gConsts.job.stateUpdates.TOOL_UPDATE_STATE   : 
            case gConsts.job.stateUpdates.JOB_RESET_DOUBT     : 
            case gConsts.job.stateUpdates.JOB_RESET_DISCARDED :             
                if ( (job.state == gConsts.job.states.DISCARDED            ) &&  // Se job.state == DISCARDED, soh reseta o state se estivermos revertendo o descarte
                     (event != gConsts.job.stateUpdates.JOB_RESET_DISCARDED) ) { 
                    break; 
                }

                newState = (tools.length > 0) ? gConsts.job.states.PARTIAL : gConsts.job.states.EMPTY;
                for (i = 0; i < tools.length; i++) {
                    switch (tools[i].state) {
                        case gConsts.tool.state.confidence.DIVERGENT : newState = gConsts.job.states.DIVERGENT; break;
                        case gConsts.tool.state.confidence.DOUBT     : newState = gConsts.job.states.DOUBT    ; break;                
                    }
                    if (newState == gConsts.job.states.DIVERGENT) { break; } // DIVERGENT tem precedencia ... se achou uma jah rege o job.state
                }
                break;        
        }        
        return newState;
    }
}
